import React, { useState, useEffect, useRef } from "react";
import style from "./Practice.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { baseurl } from "../Url";
import leftArrow from "../../assests/left arrow.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import TrophyImage from "../../assests/Trophy.png";
import SecondTrophyImage from "../../assests/SecondTrophy.png";
import ThirdTrophyImage from "../../assests/ThirdTrophy.png";
import FourthTrophyImage from "../../assests/FourthTrophy.png";
import HintImage from "../../assests/hint1.svg";
import HintImage2 from "../../assests/hint2.svg";
import ohdearimg from "../../assests/ohdearimg.png";
import { Doughnut } from "react-chartjs-2";
import Loader from "../Loder/Loader";
import lessonImage from "../../assests/online lesson.png";
import timeImage from "../../assests/Time.png";
import questionImage from "../../assests/19 Questionnaire.png";
import motivationImage from "../../assests/Motivation.png";
import { Alert, Snackbar } from "@mui/material";
import { FaCheck } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import { useSelector } from "react-redux";
// import FailedImage from "../../assests/TrainImage.png";
import { AiOutlineClose, AiOutlineDelete } from "react-icons/ai";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Coins from "../../assests/Animations/CoinsGif.gif";
import Lottie from "lottie-react";
import coinsLottie from "../../Animation/Animation -Coins.json";
import { fetchUserDetails } from "../../Slices/UserSlice";
import { useDispatch } from "react-redux";
import { DndContext, closestCenter } from "@dnd-kit/core";
import UnlockAnimation from "../../Animation/badge_animation.json"
import sprinklesGif from "../../assests/Animations/SprinklesGif.gif";
import {
  SortableContext,
  useSortable,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
// import CircularProgress from "@mui/material/CircularProgress";
import lockImage from "../../assests/lock.svg";
import lockImage2 from "../../assests/lock2.svg";
import bronze from "../../assests/BronzePracticeMedal.png";
import ohDear from "../../assests/ohDear.svg";
import sliverrank from "../../assests/silverMedal.png";
import goldrank from "../../assests/GoldPracticeMedal.png";
import SubTopic from "../PracticewithTs/SubTopic/SubTopic";
import bronzelocked from "../../assests/bronze_lock.png"
import silverlocked from "../../assests/silverLock.png"
import goldlocked from "../../assests/gold_lock.png"
import NewUnlockAnimation from "../../Animation/12345.json"


const PRACTICE_BROWSER_RELOAD_KEY = "practice_browser_reload";

const CORRECT_MESSAGES = [
  "You are correct!",
  "Correct!",
  "You got it right!",
  "You’re right!",
  "Right answer!",
  "That’s right!",
  "You answered correctly!",
  "That’s the right answer!",
  "Spot on!",
  "Correct answer!",
  "Perfect!",
];

const INCORRECT_MESSAGES = [
  "That’s not right – see the explanation below then try the next question.",
  "Keep practising - you’ll get there!",
  "Keep going – practice makes perfect!",
  "Don’t worry - you need a bit more practice, that’s all!",
];

const HIGHLIGHT_ANSWER_COLOR = "rgb(255, 122, 0)";

const normalizeHighlightAnswerHtml = (html = "") => {
  if (!html) return "";
  return String(html).replace(
    /color:\s*(#ff7a00|#FF7A00|rgb\(\s*255\s*,\s*122\s*,\s*0\s*\))/gi,
    `color: ${HIGHLIGHT_ANSWER_COLOR}`
  );
};

const getHighlightMultipleAnswers = (ranges = [], html = "") => {
  if (!ranges.length || !html) return [];
  return [normalizeHighlightAnswerHtml(html)];
};

const normalizeHighlightMultipleRangeIndex = (rangeIndex = []) => {
  if (!Array.isArray(rangeIndex)) return [];

  return rangeIndex
    .map((item) => {
      if (item && typeof item === "object" && item.start != null && item.end != null) {
        return {
          start: Number(item.start),
          end: Number(item.end),
          text: String(item.text ?? ""),
        };
      }
      return null;
    })
    .filter((item) => item && item.end > item.start)
    .sort((a, b) => a.start - b.start);
};

const normalizeHighlightWord = (text = "") =>
  String(text)
    .replace(/\u00a0/g, " ")
    .replace(/[''']/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

const highlightRangesOverlap = (startA, endA, startB, endB) =>
  startA < endB && startB < endA;

const getHighlightMultipleRangeBounds = (range) => ({
  start: Number(range.start ?? range.index),
  end: Number(range.end ?? range.index + range.length),
});

const isHighlightMultipleRangeIncorrect = (
  range,
  incorrectRanges = [],
  plainText = ""
) => {
  const { start: rangeStart, end: rangeEnd } =
    getHighlightMultipleRangeBounds(range);
  const rangeWord = normalizeHighlightWord(
    range.text || plainText.slice(rangeStart, rangeEnd) || ""
  );

  return normalizeHighlightMultipleRangeIndex(incorrectRanges).some((entry) => {
    const entryStart = Number(entry.start);
    const entryEnd = Number(entry.end);
    const entryWord = normalizeHighlightWord(entry.text);
    const apiSlice = normalizeHighlightWord(
      plainText.slice(entryStart, entryEnd)
    );

    if (!entryWord) return false;

    // Exact API span match (same occurrence)
    if (entryStart === rangeStart && entryEnd === rangeEnd) return true;

    // Overlap in plain-text / Quill offset space
    if (highlightRangesOverlap(rangeStart, rangeEnd, entryStart, entryEnd)) {
      return true;
    }

    // Incorrect span fully inside a larger user highlight (combined selection)
    if (rangeStart <= entryStart && rangeEnd >= entryEnd) {
      return true;
    }

    // Small offset drift for same word (e.g. it's vs its) — position only, not text-only
    if (
      rangeWord &&
      apiSlice &&
      rangeWord === apiSlice &&
      apiSlice === entryWord
    ) {
      const startDrift = Math.abs(rangeStart - entryStart);
      const endDrift = Math.abs(rangeEnd - entryEnd);
      if (startDrift <= 3 && endDrift <= 3) return true;
    }

    return false;
  });
};

const parseSentence = (sentence = "") => {
  if (!sentence) return [];
  let cleaned = sentence.trim();
  if (cleaned.toLowerCase().startsWith("<p>") && cleaned.toLowerCase().endsWith("</p>")) {
    cleaned = cleaned.slice(3, -4).trim();
  }
  cleaned = cleaned.replace(/^(?:<br\s*\/?>)+|(?:<br\s*\/?>)+$/gi, "").trim();

  const regex = /(<u>.*?<\/u>|<[a-zA-Z0-9]+[^>]*style=["'][^"']*color:\s*(?:rgb\(\s*255\s*,\s*122\s*,\s*0\s*\)|#ff7a00|#FF7A00)[^"']*["'][^>]*>.*?<\/[a-zA-Z0-9]+>)/gi;
  const parts = cleaned.split(regex);
  return parts.map((part) => {
    const trimmed = part.trim();
    let isDraggable = false;
    
    if (trimmed.startsWith("<") && trimmed.endsWith(">")) {
      if (/^<u>/i.test(trimmed) && /<\/u>$/i.test(trimmed)) {
        isDraggable = true;
      } else {
        const hasStyle = /style=["']/i.test(trimmed);
        const hasOrangeColor = /color:\s*(?:rgb\(\s*255\s*,\s*122\s*,\s*0\s*\)|#ff7a00|#FF7A00)/i.test(trimmed);
        if (hasStyle && hasOrangeColor) {
          isDraggable = true;
        }
      }
    }
    
    if (isDraggable) {
      const word = part.replace(/<[^>]+>/g, "").trim();
      return { isDraggable: true, word };
    }
    
    return { isDraggable: false, text: part };
  });
};

const Practice = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const state = location.state || {};
  // Normalize incoming state from SubTopic navigation
  const Topic =
    state?.singleTopic ||
    (state?.topic_id || state?.label || state?.skill_name || state?.value
      ? {
          id: state?.topic_id,
          value: state?.label || state?.skill_name || state?.value,
        }
      : "testTopic");
  const learning_id = state?.learning;
  const main_topic_id = state?.main_topic_id || state?.mainID;
  const topicNo = state?.topicNo;
  const aiID = state?.ai_id || state?.aiID;
  const skillId = state?.skill_id;
  const skillName = state?.skill_name;
  const topicId = state?.topic_id;
  const topicName = state?.topic_name;
  const titleName = state?.subtopic_title;
  const subTopicIndex = state?.subtopic_index;
  const continueFlag = Boolean(state?.continue);
  const titleNameMd = state?.subtopic_title_md;
  const subTopicIndexMd = state?.subtopic_index_md;
  const pageReload = Boolean(state?.page_reload)

  const navEntry = performance.getEntriesByType?.("navigation")?.[0];
  const isReloadNav =
    navEntry?.type === "reload" ||
    (window.performance &&
      window.performance.navigation &&
      window.performance.navigation.type === 1);
  
  // Additional state data for navigating back to /skill/list
  const pageNum = state?.pageNum;
  const title = state?.title;
  const uniqueId = state?.uniqueId;
  const singleTopic = state?.singleTopic;
  const learning = state?.learning;
  const mapped = state?.mapped;
  const mainId = state?.mainId;
  const topic_no = state?.topic_no;
  const userID = state?.userID;
  const orgID = state?.orgID;
  const fromSubTopic = state?.fromSubTopic;
  const fromNewLearningDetail = state?.fromNewLearningDetail;
  const expandedModuleIndices = state?.expandedModuleIndices;
  const scrollToPageNum = state?.scrollToPageNum;
  const scrollToUniqueId = state?.scrollToUniqueId;
  const scrollToModuleIndex = state?.scrollToModuleIndex;
  const fromTroubleSkill = location.state?.fromTroubleSkill;
  const fromTrouble = location.state?.fromTrouble;
  const fromTroubleFromLearnings = location.state?.fromTroubleFromLearnings;
  const fromTroubleFromSubtopic = location.state?.fromTroubleFromSubtopic;
  const returnToSubtopicState = location.state?.returnToSubtopicState;
  const topicIndexState = state?.topicIndex ?? pageNum;
  const topicValueState = state?.topicValue ?? title;
  const moduleNameState = state?.moduleName ?? "";
  const moduleIndexState = state?.moduleIndex ?? "";

  const practiceScrollState = {
    expandedModuleIndices,
    scrollToPageNum: scrollToPageNum ?? pageNum,
    scrollToUniqueId: scrollToUniqueId ?? uniqueId,
    scrollToModuleIndex,
  };

  const {
    userDetails,
    status: userStatus,
    error: userError,
  } = useSelector((state) => state.user);
  const USERID = localStorage.getItem("USERID");
  const OrgID = localStorage.getItem("ORGID");

  const [practice, setPractice] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPractice, setCurrentPractice] = useState({});
  const [validateClicked, setValidateClicked] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [practiceData, setPracticeData] = useState({});
  const [activeDropTarget, setActiveDropTarget] = useState(null);
  const [finishPopup, setFinishPopup] = useState(false);
  const [result, setResult] = useState(false);
  const [summaryDetail, setSummaryDetail] = useState({});
  const inputRefs = useRef({});
  const [loading, setLoading] = useState(true);
  const [resolvedContinueFlag, setResolvedContinueFlag] = useState(continueFlag);
  const [reloadDecisionPopup, setReloadDecisionPopup] = useState(false);
  const [reloadChecked, setReloadChecked] = useState(false);
  const [trialUser, setTrailUser] = useState(false);
  const [error, setError] = useState("");
  const [failedPopup, setFailedPopup] = useState(false);
  const highlightRefs = useRef({});
  const quillRef = useRef();
  const [achievementPopup, setAchievementPopup] = useState(false);
  const [collectPopup, setCollectPopup] = useState(false);
  const [carouselData, setCarouselData] = useState([]);
  const [points, setPoints] = useState("");
  const [showHint, setShowHint] = useState(false);
  const [hintDialog, setHintDialog] = useState(false);
  const hintRef = useRef();
  const [wrongAnswerCount, setWrongAnswerCount] = useState(0);
  const [storesessionId, setstoresessionId] = useState("");
  const [storemedalValue, setstoremedalValue] = useState("");
  const [storeassessmentCount, setstoreassessmentCount] = useState(1);
  console.log("medalvalue", storemedalValue);
  const [sessionPause, setsessionPause] = useState([]);
  console.log("sessionPause", sessionPause);
  const [sessionPausePopup, setSessionPausePopup] = useState(false);
  const [nextAssessmentCount, setNextAssessmentCount] = useState(null);
  const [endSession, setendSession] = useState([]);

  const [assementStatus, setassementStatus] = useState("");

  const [storesessionTime, setstoresessionTime] = useState(0);

  const [submitError, setSubmitError] = useState(false);
  const [pendingOhDear, setPendingOhDear] = useState(false);
  const [pauseTimer, setPauseTimer] = useState(false);

  const [ohDearResult, setOhDearResult] = useState(false);
  const [ohDearSummary, setOhDearSumary] = useState("");
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [elapsedSeconds, setElapsedSeconds] = useState(storesessionTime);
  const [assessmentcompletedUI, setassessmentcompletedUI] = useState(false);
  const [totalsessionTime, settotalsessionTime] = useState("");
  // const [, set] = useState(second)
  const [thresholdmark, setthreshold_mark] = useState("");
  const [percentMark, setPercentMark] = useState("");
  const [totalmarkscored, settotalmarkscored] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "" });

  const [hardSkip,setHardSkip]=useState(true)
  const [mediumSkip,setMediumSkip]=useState(true)
  const [easySkip,setEasySkip]=useState(true)
  const easySkipSnackbarShownRef = useRef(false);
  const mediumSkipSnackbarShownRef = useRef(false);
  const hardSkipSnackbarShownRef = useRef(false);
  const prevPercentMarkRef = useRef(null);
  const correctMsgIndexRef = useRef(0);
  const incorrectMsgIndexRef = useRef(0);
  const [levelSkipError, setlevelSkipError] = useState(false);

  const [bronzeUnlocked, setBronzeUnlocked] = useState(false);
  const [showBronzeAnim, setShowBronzeAnim] = useState(false);
  const [silverUnlocked, setSilverUnlocked] = useState(false);
  const [showSilverAnim, setShowSilverAnim] = useState(false);
  const [goldUnlocked, setgoldUnlocked] = useState(false);
  const [showGoldAnim, setShowGoldAnim] = useState(false);
  const [unansweredSelectDropdowns, setUnansweredSelectDropdowns] = useState([]);

  const nextSlide = () => {
    setCurrentSlideIndex((prevIndex) => (prevIndex + 1) % carouselData.length);
  };

  const prevSlide = () => {
    setCurrentSlideIndex(
      (prevIndex) => (prevIndex - 1 + carouselData.length) % carouselData.length
    );
  };
 
  const numbers = Array.from(
    { length: practice.length },
    (_, index) => index + 1
  );

  const totalCount = practice.length;
  const correctCount = Object.values(practiceData).filter(
    (data) => data.status === "correct"
  ).length;
  const incorrectCount = Object.values(practiceData).filter(
    (data) => data.status === "incorrect"
  ).length;
  const skippedCount = Object.values(practiceData).filter(
    (data) => data.status === "skipped"
  ).length;
  const resultPercentage = ohDearResult
    ? Number(ohDearSummary?.total_percent ?? percentMark) || 0
    : Number(summaryDetail?.percentage);
  const showOhDearPage = ohDearResult && resultPercentage <= 40;

  useEffect(() => {
    // Start/continue ticking while the session is active and not paused
    if (!result && !finishPopup && !pauseTimer) {
      const intervalId = setInterval(() => {
        setElapsedSeconds((prev) => prev + 1);
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [result, finishPopup, pauseTimer]);

  const formatTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600)
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((totalSeconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const seconds = Math.floor(totalSeconds % 60)
      .toString()
      .padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    if (percentMark >= 60) {
      if (!bronzeUnlocked) {
        setBronzeUnlocked(true);
        setShowBronzeAnim(true);
        setTimeout(() => setShowBronzeAnim(false), 3500);
      }
    } else {
      setBronzeUnlocked(false);
    }
  }, [percentMark]);

  useEffect(() => {
    if (percentMark >= 80) {
      if (!silverUnlocked) {
        setSilverUnlocked(true);
        setShowSilverAnim(true);
        setTimeout(() => setShowSilverAnim(false), 3500);
      }
    } else {
      setSilverUnlocked(false);
    }
  }, [percentMark]);

  useEffect(() => {
    if (assementStatus === "completed" || percentMark >= 100) {
      if (!goldUnlocked) {
        setgoldUnlocked(true);
        setShowGoldAnim(true);
        setTimeout(() => setShowGoldAnim(false), 3500);
      }
    } else {
      setgoldUnlocked(false);
    }
  }, [assementStatus, percentMark]);

  useEffect(() => {
    const current = Number(percentMark);
    if (percentMark === "" || percentMark == null || Number.isNaN(current)) {
      return;
    }

    const prev = prevPercentMarkRef.current;
    if (prev !== null) {
      const droppedBelowThreshold =
        (prev >= 100 && current < 100) ||
        (prev >= 80 && current < 80) ||
        (prev >= 60 && current < 60);

      if (droppedBelowThreshold) {
        setSnackbar({
          open: true,
          message: "Oh no, you’ve lost some points.",
        });
      }
    }

    prevPercentMarkRef.current = current;
  }, [percentMark]);

  // useEffect(() => {
  //   if (percentMark >= 100 ) {
  //     setSnackbar({ open: true, message: "🏅 Hard Medal Unlocked!" });
  //   } else if (percentMark >= 80 ) {
  //     setSnackbar({ open: true, message: "🥈 Medium Medal Unlocked!" });
  //   } else if (percentMark >= 60 ) {
  //     setSnackbar({ open: true, message: "🥉 Easy Medal Unlocked!" });
  //   }
  // }, [percentMark]);

  const fetchpauseSession = async () => {
    const token = localStorage.getItem("access-token");
    if (token) {
      try {
        const response = await fetch(`${baseurl}/practice/session-end`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            session_id: storesessionId,
            Continue: true,
            main_topic_id: main_topic_id,
          }),
        });

        if (response.ok) {
          const data = await response.json();
          if (data?.status_code === 200) {
            setsessionPause(data?.data);
            if (data?.data) {
              setSessionPausePopup(true);
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const fetchEndSession = async () => {
    const token = localStorage.getItem("access-token");
    if (token) {
      try {
        const response = await fetch(`${baseurl}/practice/session-end`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            session_id: storesessionId,
            Continue: true,
            main_topic_id: main_topic_id,
          }),
        });

        if (response.ok) {
          const data = await response.json();
          console.log(data);

          if (data?.status_code === 200) {
            setendSession(data?.data);
            if (data?.data) {
              setFinishPopup(true);
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  };
  const applySessionSummary = (sessionData) => {
    if (!sessionData || Array.isArray(sessionData)) return;

    const threshold = Number(sessionData.threshold_marks) || 0;
    const totalScored = Number(sessionData.total_mark_scored) || 0;
    const sessionTime = Number(sessionData.session_time_taken) || 0;
    const totalPercent =
      sessionData.total_percent != null && sessionData.total_percent !== ""
        ? Number(sessionData.total_percent)
        : threshold > 0
          ? Math.round((totalScored / threshold) * 100)
          : 0;

    setOhDearSumary({
      threshold_marks: threshold,
      total_mark_scored: totalScored,
      session_time_taken: sessionTime,
      total_percent: totalPercent,
    });
    settotalsessionTime(sessionTime);
    setPercentMark(totalPercent);
    settotalmarkscored(totalScored);
    setthreshold_mark(threshold);
    setendSession(sessionData);
  };

  const EndTest = async () => {
    const token = localStorage.getItem("access-token");
    if (!token) return null;

    try {
      const response = await fetch(`${baseurl}/practice/session-end`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          session_id: storesessionId,
          Continue: false,
          main_topic_id: main_topic_id,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        if (data?.status_code === 200) {
          return data?.data ?? null;
        }
      }
    } catch (error) {
      console.error(error);
    }
    return null;
  };

  const handleConfirmEndPractice = async (e) => {
    e.preventDefault();
    setFinishPopup(false);
    setSubmitError(false);

    const sessionData = await EndTest();
    if (sessionData) {
      applySessionSummary(sessionData);
    } else if (
      endSession &&
      typeof endSession === "object" &&
      !Array.isArray(endSession)
    ) {
      applySessionSummary(endSession);
    } else {
      setOhDearSumary({
        threshold_marks: Number(thresholdmark) || 0,
        total_mark_scored: Number(totalmarkscored) || 0,
        session_time_taken:
          Number(totalsessionTime) || Number(elapsedSeconds) || 0,
        total_percent: Number(percentMark) || 0,
      });
    }

    setOhDearResult(true);
    setResult(true);
  };

  const getEndSession = async (redirectPath = "/tab") => {
    const token = localStorage.getItem("access-token");
    if (token) {
      try {
        const response = await fetch(`${baseurl}/practice/session-end`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            session_id: storesessionId,
            Continue: false,
            main_topic_id: main_topic_id,
          }),
        });

        if (response.ok) {
          const data = await response.json();
          if (data?.status_code === 200) {
            setFinishPopup(false);
            if (typeof redirectPath === "object" && redirectPath?.pathname) {
              navigate(redirectPath.pathname, { state: redirectPath.state || {} });
            } else {
              navigate(redirectPath || "/tab");
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  };
  console.log("fromTroubleSkill ======>", fromTroubleSkill);
  const handleGoToSkills = () => {
    if (fromTroubleFromLearnings || (fromTroubleFromSubtopic && returnToSubtopicState) || fromTroubleSkill || fromTrouble) {
      navigate("/focus-zone");
    } else if (fromSubTopic) {
      navigate("/skill/list", {
        state: {
          pageNum,
          title,
          uniqueId,
          aiId: aiID,
          main_topic_id,
          topic_id: topicId,
          singleTopic,
          learning,
          mapped,
          mainId,
          topic_no,
          userID,
          orgID,
          fromSubTopic: true,
          fromNewLearningDetail,
          ...practiceScrollState,
        },
      });
    } else if (fromNewLearningDetail) {
      navigate("/skill/list", {
        state: {
          pageNum,
          title,
          uniqueId,
          aiId: aiID,
          main_topic_id,
          topic_id: topicId,
          singleTopic,
          learning,
          mapped,
          mainId,
          topic_no,
          userID,
          orgID,
          fromSubTopic,
          fromNewLearningDetail: true,
          ...practiceScrollState,
        },
      });
    } else {
      navigate("/skill/list", {
        state: {
          pageNum,
          title,
          uniqueId,
          aiId: aiID,
          main_topic_id,
          topic_id: topicId,
          singleTopic,
          learning,
          mapped,
          mainId,
          topic_no,
          userID,
          orgID,
          fromSubTopic,
          fromNewLearningDetail,
          ...practiceScrollState,
        },
      });
    }
  };


  const handleOptionClick = (option, index) => {
    const uniqueId = currentPractice.unique_id;
    const isMultiSelect = currentPractice.isMultiSelect;

    setPracticeData((prev) => {
      const prevAnswers = prev[uniqueId]?.answers || [];
      let newAnswers;

      if (isMultiSelect) {
        if (prevAnswers.includes(option)) {
          newAnswers = prevAnswers.filter((ans) => ans !== option);
        } else {
          newAnswers = [...prevAnswers, option];
        }
      } else {
        newAnswers = [option];
      }

      return {
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: newAnswers,
        },
      };
    });

    setSelectedOptions((prev) => {
      if (isMultiSelect) {
        const selectedIndexes = prev[uniqueId] || [];
        return {
          ...prev,
          [uniqueId]: selectedIndexes.includes(index)
            ? selectedIndexes.filter((i) => i !== index)
            : [...selectedIndexes, index],
        };
      } else {
        return {
          ...prev,
          [uniqueId]: [index],
        };
      }
    });
  };

  const handleInputChange = (index, value) => {
    const uniqueId = currentPractice.unique_id;
    setPracticeData((prev) => {
      const updatedAnswers = [...(prev[uniqueId]?.answers || [])];
      updatedAnswers[index] = value;
      return {
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: updatedAnswers,
        },
      };
    });
  };

  const formatQuestionText = (text) => {
    let formattedText = text
      .replace(/<\/?p>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/(<br\s*\/?>\s*)+/g, "<br>")
      .replace(/‘|’/g, "'")
      .replace(/“|”/g, '"')
      .trim();

    console.log("Formatted Text:", formattedText);
    return <span dangerouslySetInnerHTML={{ __html: formattedText }} />;
  };

  const stripHtmlForCompare = (value) =>
    String(value ?? "")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

  const isDragDropCellIncorrect = (incorrectIndexes, colIndex, rowIndex) => {
    if (!Array.isArray(incorrectIndexes)) return false;
    return incorrectIndexes.some(
      (entry) =>
        Number(entry?.column) === colIndex && Number(entry?.row) === rowIndex
    );
  };

  const getDragDropTableCellClass = () => style.tableCell;

  const getDragDropCardInCellClass = (
    answered,
    incorrectIndexes,
    colIndex,
    rowIndex,
    cellValue,
    sentenceType
  ) => {
    const classes = [style.cardInCell];
    if (sentenceType) classes.push(style.cardInCellSentence);
    if (!answered) return classes.join(" ");

    if (isDragDropCellIncorrect(incorrectIndexes, colIndex, rowIndex)) {
      classes.push(style.wrongCard);
    } else if (stripHtmlForCompare(cellValue)) {
      classes.push(style.correctCard);
    }
    return classes.join(" ");
  };

  const renderDragDropTableBody = ({
    columns,
    answered,
    incorrectIndexes,
    sentenceType,
    onDragOver,
    onDrop,
    onDelete,
  }) => {
    const rowCount = columns?.[0]?.values?.length || 0;

    return [...Array(rowCount)].map((_, rowIndex) => (
      <tr key={rowIndex}>
        {columns.map((col, colIndex) => {
          const cellValue = col.values[rowIndex];
          const hasCellValue = Boolean(stripHtmlForCompare(cellValue));

          return (
            <td
              key={`${colIndex}-${rowIndex}`}
              className={getDragDropTableCellClass()}
              onDragOver={(event) => !answered && onDragOver?.(event)}
              onDrop={(event) =>
                !answered && onDrop?.(event, colIndex, rowIndex)
              }
            >
              {hasCellValue ? (
                <div
                  className={getDragDropCardInCellClass(
                    answered,
                    incorrectIndexes,
                    colIndex,
                    rowIndex,
                    cellValue,
                    sentenceType
                  )}
                  draggable={false}
                  onDragStart={(e) => e.preventDefault()}
                >
                  <span
                    className={style.cardText}
                    dangerouslySetInnerHTML={{ __html: cellValue }}
                  />
                  {onDelete && !answered && (
                    <AiOutlineDelete
                      className={style.deleteButton}
                      onClick={() => onDelete(colIndex, rowIndex)}
                    />
                  )}
                </div>
              ) : null}
            </td>
          );
        })}
      </tr>
    ));
  };

  const renderQuestionWithInputs = (question) => {
    const parts = question.split(/\[blank (\d+)\]/);
    const uniqueId = currentPractice.unique_id;
    const status = practiceData[uniqueId]?.status;
    const answered = practiceData[uniqueId]?.answered;
    const incorrectIndexes =practiceData[uniqueId]?.incorrect_index || [];

    return (
      <p>
        {" "}
        {/* Flexbox container */}
        {parts.map((part, index) => {
          if (index % 2 === 1) {
            const blankIndex = parseInt(parts[index], 10) - 1;
            // let inputStyle = {};

            // if (status === "correct") {
            //   inputStyle = { color: "#00DFC7" };
            // } else if (status === "incorrect") {
            //   inputStyle = { color: "#FF2443" };
            // } else {
            //   inputStyle = { color: "#FF7A00" };
            // }
            const isWrong =answered &&incorrectIndexes.map(i => i - 1).includes(blankIndex);


            // Calculate dynamic width based on input value length
            const inputValue =
              practiceData[uniqueId]?.answers[blankIndex] || "";
            const calculatedWidth = inputValue.length * 10 + 20;
            const inputWidth = `${Math.min(
              Math.max(calculatedWidth, 50),
              500
            )}px`;
            const inputStyle = answered
            ? { color: isWrong ? "#FF2443" : "#00DFC7" }
            : { color: "#FF7A00" };

            return (
              <React.Fragment key={index}>
                <input
                  spellCheck="false"
                  autoCorrect="off"
                  autoComplete="off"
                  type="text"
                  value={inputValue}
                  onChange={(e) =>
                    handleInputChange(blankIndex, e.target.value)
                  }
                  className={style.blankInput}
                  disabled={practiceData[currentPractice.unique_id]?.answered}
                  style={{ ...inputStyle, width: inputWidth }}
                />
              </React.Fragment>
            );
          } else {
            return (
              <React.Fragment key={index}>
                {formatQuestionText(part)}
              </React.Fragment>
            );
          }
        })}
      </p>
    );
  };

  const renderQuestionWithDropdowns = (question, options) => {
    const uniqueId = currentPractice.unique_id;
    const parts = question.split(/(\[dropdown-\d+\])/);
    const answered = practiceData[uniqueId]?.answered;
    const incorrectIndexes =practiceData[uniqueId]?.incorrect_index || [];

    return (
      <p>
        {parts.map((part, index) => {
          const dropdownMatch = part.match(/\[dropdown-(\d+)\]/);

          if (dropdownMatch) {
            const dropdownId = parseInt(dropdownMatch[1], 10);
            const dropdownOptions =
              options.find((option) => option.id === dropdownId)?.options || [];
            const isWrong = answered && incorrectIndexes.map(i => i - 1).includes(dropdownId - 1);

            return (
              <React.Fragment key={index}>
                <select
                  value={practiceData[uniqueId]?.answers?.[dropdownId] || ""}
                  onChange={(e) => {
                    const newAnswers = {
                      ...(practiceData[uniqueId]?.answers || {}),
                    };
                    newAnswers[dropdownId] = e.target.value;
                    setUnansweredSelectDropdowns((prev) =>
                      prev.filter((id) => id !== dropdownId)
                    );
                    setPracticeData((prev) => ({
                      ...prev,
                      [uniqueId]: {
                        ...prev[uniqueId],
                        answers: newAnswers,
                      },
                    }));
                  }}
                  className={`${style.blankDropdown} ${
                    unansweredSelectDropdowns.includes(dropdownId)
                      ? style.blankDropdownMissing
                      : ""
                  }`}
                  disabled={practiceData[currentPractice.unique_id]?.answered}
                  style={
                    answered
                      ? isWrong
                        ? { color: "#ff0829" }
                        : { color: "#00e9d2" }
                      : { color: "#000" }
                  }
                >
                  <option disabled value="">
                    Select
                  </option>
                  {dropdownOptions.map((option, i) => (
                    <option key={i} value={option}>
                      {String(option || "")
                        .replace(/<[^>]*>/g, "")
                        .replace(/&nbsp;/gi, " ")
                        .replace(/\u00a0/g, " ")
                        .trim() || option}
                    </option>
                  ))}
                </select>
              </React.Fragment>
            );
          }
          return (
            <React.Fragment key={index}>
              {formatQuestionText(part)}
            </React.Fragment>
          );
        })}
      </p>
    );
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const sourceDroppableId = result.source.droppableId;
    const destinationDroppableId = result.destination.droppableId;
    const uniqueId = currentPractice.unique_id;

    setPracticeData((prev) => {
      const prevAnswers = prev[uniqueId]?.answers || { left: [], right: [] };
      const prevRightOrder =
        prev[uniqueId]?.rightOrder ||
        (prevAnswers.right || []).map((_, i) => i);

      let newAnswers = { ...prevAnswers };
      let newRightOrder = [...prevRightOrder];

      if (
        sourceDroppableId.startsWith("left") &&
        destinationDroppableId.startsWith("left")
      ) {
        const items = Array.from(newAnswers.left);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        newAnswers.left = items;
      } else if (
        sourceDroppableId.startsWith("right") &&
        destinationDroppableId.startsWith("right")
      ) {
        const items = Array.from(newAnswers.right);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        newAnswers.right = items;

        const [reorderedPos] = newRightOrder.splice(result.source.index, 1);
        newRightOrder.splice(result.destination.index, 0, reorderedPos);
      }

      return {
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: newAnswers,
          rightOrder: newRightOrder,
        },
      };
    });
  };
  const renderFillBlankQuestionWithAnswer = (question, actualAns = []) => {
    if (!question) return null;

    const answerByKey = {};
    const fallbackValues = [];
    const queue = Array.isArray(actualAns) ? [...actualAns] : [actualAns];

    while (queue.length > 0) {
      const item = queue.shift();
      if (Array.isArray(item)) {
        queue.push(...item);
        continue;
      }
      if (!item || typeof item !== "object") continue;

      Object.entries(item).forEach(([rawKey, rawValue]) => {
        const value = String(rawValue ?? "").trim();
        fallbackValues.push(value);
        const numericKey = Number(rawKey);
        if (!Number.isNaN(numericKey)) {
          answerByKey[numericKey] = value;
        }
      });
    }

    let fallbackIndex = 0;
    const filledQuestion = question.replace(
      /\[blank\s*(\d+)\s*\]/gi,
      (_, blankNo) => {
        const key = Number(blankNo);
        const mappedAnswer =
          answerByKey[key] ??
          answerByKey[key - 1] ??
          fallbackValues[fallbackIndex++] ??
          "";
        return `<span>${mappedAnswer}</span>`;
      }
    );

    return (
      <div
        className={style.fillBlankAnswer}
        dangerouslySetInnerHTML={{ __html: filledQuestion }}
      />
    );
  };
  const renderSelectAnswersQuestionWithAnswer = (question, actualAns = []) => {
    if (!question) return null;
    const answerByKey = {};
    const fallbackValues = [];
  
    actualAns.forEach((answerObj) => {
      Object.entries(answerObj || {}).forEach(([rawKey, rawValue]) => {
        const value = String(rawValue ?? "").trim();
        fallbackValues.push(value);
        const numericKey = Number(rawKey);
        if (!Number.isNaN(numericKey)) {
          answerByKey[numericKey] = value;
        }
      });
    });
  
    let fallbackIndex = 0;
    const filledQuestion = question.replace(/\[dropdown-(\d+)\]/g, (_, dropdownNo) => {
      const key = Number(dropdownNo);
      const mappedAnswer =
        answerByKey[key] ??
        answerByKey[key - 1] ??
        fallbackValues[fallbackIndex++] ??
        "";
      return `<span class="${style.selectAnswerBox}">${mappedAnswer}</span>`;
    });
  
    return (
      <div
        className={style.fillBlankAnswer}
        dangerouslySetInnerHTML={{ __html: filledQuestion }}
      />
    );
  };
  
  const renderHighlightQuestionWithAnswer = (questionHtml, actualAns = []) => {
    const cleanedAnswers = (actualAns || [])
      .map((ans) => String(ans ?? "").trim())
      .filter((ans) => ans.length > 0);
  
    return (
      <div className={style.fillBlankAnswer}>
        <div
          dangerouslySetInnerHTML={{
            __html: questionHtml || "",
          }}
        />
      </div>
    );
  };
  useEffect(() => {
    setUnansweredSelectDropdowns([]);
  }, [currentPractice?.unique_id]);

  const handleArrangeDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const uniqueId = currentPractice.unique_id;
    const items = [...(practiceData[uniqueId]?.answers || [])];

    const oldIndex = items.findIndex(
      (_, index) => `option-${index}` === active.id
    );
    const newIndex = items.findIndex(
      (_, index) => `option-${index}` === over.id
    );

    if (oldIndex !== -1 && newIndex !== -1) {
      const newItems = arrayMove(items, oldIndex, newIndex);

      setPracticeData((prev) => ({
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: newItems,
        },
      }));
    }
  };

  const SortableItem = ({ id, option, index, incorrectIndexes, isSentenceType }) => {
    const { attributes, listeners, setNodeRef, transform, transition } =
      useSortable({ id });

    const styles = {
      transform: CSS.Transform.toString(transform),
      transition,
      touchAction: "none", // Prevents flickering
    };
    const isWrong =practiceData[currentPractice.unique_id]?.answered &&incorrectIndexes?.map((i) => i - 1).includes(index);
    const isCorrect = practiceData[currentPractice.unique_id]?.answered && !isWrong;

    return (
      <div
        ref={setNodeRef}
        style={styles}
        {...attributes}
        {...listeners}
        className={`${style.reArrangeCard} ${
                  isSentenceType ? style.reArrangeCardSentence : ""
                } ${
                  isSentenceType && (isWrong || isCorrect)
                    ? style.reArrangeSentenceResultDotted
                    : ""
                } ${
                  isWrong ? style.errorCard : ""
                } ${
                  isCorrect ? style.correctCard : ""
                }`}
      >
        <p
          dangerouslySetInnerHTML={{
            __html: String(option ?? "")
              .replace(/<p>/gi, "")
              .replace(/<\/p>/gi, "")
              .replace(/&nbsp;/g, " "),
          }}
        />
      </div>
    );
  };

  const handleCellValueChange = (
    rowIndex,
    colIndex,
    value,
    clueID,
    clueNumber
  ) => {
    const uniqueId = currentPractice.unique_id;

    setPracticeData((prevData) => {
      const newAnswers =
        prevData[uniqueId]?.answers.map((row, i) =>
          row.map((cell, j) =>
            i === rowIndex && j === colIndex
              ? { ...cell, cluevalue: value.toUpperCase(), clueID, clueNumber }
              : cell
          )
        ) || [];

      return {
        ...prevData,
        [uniqueId]: {
          ...prevData[uniqueId],
          answers: newAnswers,
        },
      };
    });
    const rows = practiceData[uniqueId]?.answers.length || 0;
    const cols = practiceData[uniqueId]?.answers[0]?.length || 0;

    let nextRowIndex = rowIndex + 1;
    let nextColIndex = colIndex;

    if (nextRowIndex >= rows) {
      nextColIndex += 1;
      nextRowIndex = 0;
    }
    if (
      nextRowIndex < rows &&
      inputRefs.current[uniqueId]?.[nextRowIndex * cols + nextColIndex]
    ) {
      const nextInputRef =
        inputRefs.current[uniqueId][nextRowIndex * cols + nextColIndex];
      if (nextInputRef) {
        nextInputRef.focus();
      }
    }
  };

  const getBackgroundColor = (status) => {
    switch (status) {
      case "correct":
        return "#00DFC7";
      case "incorrect":
        return "#FF7C8E";
      default:
        return "transparent";
    }
  };

  const getHighlightColor = (status) => {
    switch (status) {
      case "correct":
        return "#00FFC1";
      case "incorrect":
        return "#FF7C8E";
      default:
        return "#FF7A00";
    }
  };
  const handleNext = () => {
    // If an Oh dear popup is pending, show it now and stop navigation
    if (pendingOhDear) {
      setPendingOhDear(false);
      setSubmitError(true);
      return;
    }
    // If we buffered a next assessment count from the submit API,
    // apply it now when moving to the next question
    if (nextAssessmentCount !== null && nextAssessmentCount !== undefined) {
      setstoreassessmentCount(nextAssessmentCount);
      setNextAssessmentCount(null);
    }
    const isLastQuestion = currentIndex + 1 >= practice.length;

    if (!isLastQuestion) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      setPendingOhDear(true);
      if (assementStatus === "completed") {
        setassessmentcompletedUI(true);
        EndTest().then((sessionData) => {
          if (sessionData) applySessionSummary(sessionData);
        });
        setResult(true);
      }
    }

    setValidateClicked(false);
    setSubmitLoading(false);
  };

  const handleSkip = () => {
    const uniqueId = currentPractice?.unique_id;
    const currentStatus = practiceData[uniqueId]?.status;
    // Allow skipping if status is "viewed", empty string, or undefined (not yet answered)
    if (currentStatus === "viewed" || currentStatus === "" || !currentStatus) {
      setPracticeData((prev) => ({
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          status: "skipped",
        },
      }));
    }

    // Send validation with empty answer array on skip
    try {
      const questionId = currentPractice.id
        ? currentPractice.id.toString()
        : "";

      // Debug payload for highlight questions
      const apiPayload = {
        Organization_ID: userDetails && userDetails.org_id,
        topic_id: topicId,
        topic_name: topicName,
        question:
          currentPractice.type === "highlight" ||
          currentPractice.type === "highlight_multiple"
            ? typeof currentPractice.question === "string"
              ? currentPractice.question
              : ""
            : currentPractice.question,
        question_id: questionId,
        answer:
          currentPractice.type === "highlight" ||
          currentPractice.type === "highlight_multiple"
            ? [] // Send array with empty string for highlight questions
            : [],
        ai_id: aiID,
        main_topic_id: main_topic_id,
        user_id: userDetails && userDetails._id?.$oid,
        question_type: currentPractice.type,
        case_sensitive:
          currentPractice.type === "fill in the blanks"
            ? currentPractice.case_sensitive ?? false
            : false,
        shuffled_answer:
          currentPractice.type === "fill in the blanks"
            ? currentPractice.shuffled_answer ?? false
            : false,
        options:
          currentPractice.type === "highlight" ||
          currentPractice.type === "highlight_multiple"
            ? []
            : Array.isArray(currentPractice.options)
            ? currentPractice.options
            : currentPractice.options
            ? [currentPractice.options]
            : [],
        unique_id: currentPractice.unique_id,
        generated_by: currentPractice.generation === "admin" ? "admin" : "",
        left: currentPractice.left ? currentPractice.left : [],
        right: currentPractice.right ? currentPractice.right : [],
        actual_ans:
          currentPractice.type === "cross word puzzle"
            ? currentPractice.options
            : currentPractice.type === "highlight" ||
              currentPractice.type === "highlight_multiple"
            ? Array.isArray(currentPractice?.answer)
              ? currentPractice.answer
              : currentPractice?.answer
              ? [currentPractice.answer]
              : []
            : Array.isArray(currentPractice.answer)
            ? currentPractice.answer
            : currentPractice.answer
            ? [currentPractice.answer]
            : [],
        question_explained:
          currentPractice.type === "highlight" ||
          currentPractice.type === "highlight_multiple"
            ? typeof currentPractice.question_explained === "string"
              ? currentPractice.question_explained
              : ""
            : currentPractice.question_explained,
        time_taken: "",
        markif_correct: currentPractice.mark,
        markif_incorrect: currentPractice.negative_mark,
        session_id: storesessionId,
        session_time_taken: elapsedSeconds,
      };

      // Log the payload for debugging highlight questions
      if (
        currentPractice.type === "highlight" ||
        currentPractice.type === "highlight_multiple"
      ) {
        console.log("Highlight Skip Payload:", apiPayload);
        console.log("currentPractice:", currentPractice);
      }

      fetch(`${baseurl}/assessment/practice-validation`, {
        method: "POST",
        body: JSON.stringify(apiPayload),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          // Buffer the next question's assessment_count on skip as well
          setNextAssessmentCount(data?.data?.assessment_count ?? null);
          setthreshold_mark(data?.data?.threshold_marks);
          setPercentMark(data?.data?.total_percent);
          settotalmarkscored(data?.data?.total_mark_scored);
          setEasySkip(data.data.easy_skip);
          setMediumSkip(data.data.medium_skip);
          setHardSkip(data.data.hard_skip);
          // For skip, we move on immediately, so update the displayed count now
          if (data?.data?.assessment_count !== undefined) {
            setstoreassessmentCount(data.data.assessment_count);
          }
          if (data?.data) {
            setOhDearSumary({
              threshold_marks: data.data.threshold_marks ?? 0,
              total_mark_scored: data.data.total_mark_scored ?? 0,
              session_time_taken: data.data.session_time_taken ?? 0,
              total_percent: data.data.total_percent?? 0,
            });
          }
          const newAssessmentRaw = data?.data?.new_assessment;

          if (newAssessmentRaw) {
            const mapAssessment = (practiceItem, indexOffset) => {
              const baseQuestion = {
                ...practiceItem,
                question_no: indexOffset,
              };
              if (
                practiceItem.type === "Match the following" ||
                practiceItem.type === "Match the following with image"
              ) {
                return { ...baseQuestion, draggable: "right" };
              } else if (practiceItem.type === "multiple choices") {
                const isMultiSelect = (practiceItem.answer || []).length > 1;
                return { ...baseQuestion, isMultiSelect };
              } else if (
                practiceItem.type === "fill in the blanks" ||
                practiceItem.type === "select the answers"
              ) {
                return {
                  ...baseQuestion,
                  question: (practiceItem.question || "").replace(
                    /<\/p>/g,
                    "</p><br/>"
                  ),
                };
              }
              return baseQuestion;
            };
            setPractice((prev) => {
              const nextIndex = (prev?.length || 0) + 1;
              const mapped = mapAssessment(newAssessmentRaw, nextIndex);
              return [...(prev || []), mapped];
            });

            // Advance to the newly appended question
            setCurrentIndex((prev) => prev + 1);
            console.log("medalvalue", storemedalValue);
          } else {
            // No new question returned on skip; only show Oh dear if not completed/achievement flow
            if (data?.assessment_status !== "completed") {
              setSubmitError(true);
            }
          }
        })
        .catch(() => {});
    } catch (e) {}

    if (uniqueId && practiceData[uniqueId]) {
      const currentAssmnt = practice[currentIndex];
      let resetAnswers;
      let resetHighlightContent = "";
      let resetLastSelectedText = "";
      let resetAcrossClues = [];
      let resetDownClues = [];
      let highlightMultipleContent = "";
      let resetRightOrder = [];

      if (
        currentAssmnt.type === "Match the following" ||
        currentAssmnt.type === "Match the following with image"
      ) {
        const filteredLeft = (currentAssmnt.left || []).filter(
          (leftData) => leftData.trim() !== ""
        );
        const filteredRight = (currentAssmnt.right || []).filter(
          (rightData) => rightData.trim() !== ""
        );
        resetAnswers = {
          left: filteredLeft,
          right: filteredRight,
        };
        resetRightOrder = filteredRight.map((_, i) => i);
      } else if (currentAssmnt.type === "Rearrange") {
        resetAnswers = currentAssmnt.options || [];
      } else if (currentAssmnt.type === "cross word puzzle") {
        resetAnswers = currentAssmnt.options.map((row) =>
          row.map((cell) => ({
            clueID: cell.clueID || "",
            clueNumber: cell.clueNumber,
            cluevalue: "",
            disabled: cell.cluevalue === "",
          }))
        );

        resetAcrossClues = currentAssmnt.left.map((clueObj) => ({
          id: clueObj.id,
          number: clueObj.number,
          clue: clueObj.clue,
          answer: "",
        }));
        resetDownClues = currentAssmnt.right.map((clueObj) => ({
          id: clueObj.id,
          number: clueObj.number,
          clue: clueObj.clue,
          answer: "",
        }));
      } else if (currentAssmnt.type === "highlight") {
        resetHighlightContent =
          currentAssmnt.options.replace(
            /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
            "$1"
          ) || "";
        resetHighlightContent =
          resetHighlightContent.replace(/<span[^>]*>(.*?)<\/span>/g, "$1") ||
          "";

        resetLastSelectedText = "";
      } else if (currentAssmnt.type === "highlight_multiple") {
        highlightMultipleContent = currentAssmnt.options.replace(
          /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
          "$1"
        );

        highlightMultipleContent = highlightMultipleContent.replace(
          /<span[^>]*>(.*?)<\/span>/g,
          "$1"
        );
        resetAnswers = [];
      } else if (currentAssmnt.type === "Drag and Drop" || currentAssmnt.type === "drag and drop_v2") {
        const updatedAnswer = currentAssmnt.answer.map((item) => {
          return {
            ...item,
            values: item.values.map(() => ""),
          };
        });
        resetAnswers = updatedAnswer;
      } else {
        resetAnswers = [];
      }

      setPracticeData((prev) => ({
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: resetAnswers,
          rightOrder: resetRightOrder,
          highlightContent: resetHighlightContent,
          lastSelectedText: resetLastSelectedText,
          cluesAcross: resetAcrossClues,
          cluesDown: resetDownClues,
          previousRange: null,
          highlightMultipleContent: highlightMultipleContent,
          highlightMultipleRange: [],
        },
      }));
      setSelectedOptions((prev) => {
        const { [uniqueId]: _, ...rest } = prev;
        return rest;
      });
    }

    // Proceed to next question only if it already exists; otherwise wait for API to append
    setCurrentIndex((prevIndex) => {
      const hasNext = prevIndex + 1 < practice.length;
      return hasNext ? prevIndex + 1 : prevIndex;
    });
    setValidateClicked(false);
  };
   useEffect(() => {
    if (!easySkip && !easySkipSnackbarShownRef.current && storemedalValue === "easy") {
      setlevelSkipError(true);
      easySkipSnackbarShownRef.current = true; 
      return;
    }
    if (!mediumSkip && !mediumSkipSnackbarShownRef.current && storemedalValue === "medium"){
      setlevelSkipError(true);
      mediumSkipSnackbarShownRef.current = true; 
      return;
    }
    if (!hardSkip && !hardSkipSnackbarShownRef.current && storemedalValue === "hard"){
      setlevelSkipError(true);
      hardSkipSnackbarShownRef.current = true; 
      return;
    }
  }, [easySkip,mediumSkip,hardSkip]);

  const handleDragStart = (event, option) => {
    event.dataTransfer.setData("text/plain", option);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event, colIndex, rowIndex) => {
    event.preventDefault();
    const droppedValue = event.dataTransfer.getData("text/plain");

    setPracticeData((prev) => {
      const updatedAnswers = [...prev[currentPractice.unique_id].answers];
      updatedAnswers[colIndex].values[rowIndex] = droppedValue;

      return {
        ...prev,
        [currentPractice.unique_id]: {
          ...prev[currentPractice.unique_id],
          answers: updatedAnswers,
        },
      };
    });
  };

  const handleDeleteDroppedCell = (colIndex, rowIndex) => {
    setPracticeData((prev) => {
      const updatedAnswers = [...prev[currentPractice.unique_id].answers];
      updatedAnswers[colIndex].values[rowIndex] = ""; // Clear the dropped value

      return {
        ...prev,
        [currentPractice.unique_id]: {
          ...prev[currentPractice.unique_id],
          answers: updatedAnswers,
        },
      };
    });
  };

  const handleDeleteDroppedCellV2 = (colIndex, rowIndex, uniqueId) => {
    setPracticeData((prev) => {
      const updatedAnswers = [...prev[uniqueId].answers];
      updatedAnswers[colIndex].values[rowIndex] = ""; // Clear the dropped value

      return {
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: updatedAnswers,
        },
      };
    });
  };

  const renderDragDropTableBodyV2 = ({
    columns,
    answered,
    incorrectIndexes,
    onDelete,
    uniqueId,
  }) => {
    const rowCount = columns?.[0]?.values?.length || 0;

    return [...Array(rowCount)].map((_, rowIndex) => (
      <tr key={rowIndex}>
        {columns.map((col, colIndex) => {
          const cellValue = col.values[rowIndex];
          const hasCellValue = Boolean(cellValue && cellValue.trim());

          let cardClass = style.cardInSlotV2;
          if (answered) {
            if (isDragDropCellIncorrect(incorrectIndexes, colIndex, rowIndex)) {
              cardClass += ` ${style.cardInSlotIncorrectV2}`;
            } else if (hasCellValue) {
              cardClass += ` ${style.cardInSlotCorrectV2}`;
            }
          }

          return (
            <td
              key={`${colIndex}-${rowIndex}`}
              className={style.dragTableCellV2}
            >
              <div
                className={`${style.dropSlotV2} ${
                  activeDropTarget?.colIndex === colIndex &&
                  activeDropTarget?.rowIndex === rowIndex
                    ? style.dropSlotActiveV2
                    : ""
                }`}
                onDragOver={(event) => {
                  event.preventDefault();
                  if (!answered) {
                    setActiveDropTarget({ colIndex, rowIndex });
                  }
                }}
                onDragLeave={() => {
                  if (!answered) {
                    setActiveDropTarget(null);
                  }
                }}
                onDrop={(event) => {
                  event.preventDefault();
                  setActiveDropTarget(null);
                  if (!answered) {
                    const droppedValue = event.dataTransfer.getData("text/plain");
                    if (droppedValue) {
                      setPracticeData((prev) => {
                        const updatedAnswers = [...prev[uniqueId].answers];
                        updatedAnswers[colIndex].values[rowIndex] = droppedValue;
                        return {
                          ...prev,
                          [uniqueId]: {
                            ...prev[uniqueId],
                            answers: updatedAnswers,
                          },
                        };
                      });
                    }
                  }
                }}
              >
                {hasCellValue ? (
                  <div className={cardClass}>
                    <p>{cellValue}</p>
                    {onDelete && !answered && (
                      <AiOutlineDelete
                        onClick={() => onDelete(colIndex, rowIndex)}
                      />
                    )}
                  </div>
                ) : null}
              </div>
            </td>
          );
        })}
      </tr>
    ));
  };

  async function practiceGet(continueValue = resolvedContinueFlag) {
    if (pageReload){
    await fetch(`${baseurl}/practice/assessment-generation`, {
      method: "POST",
      body: JSON.stringify({
        User_ID: USERID,
        main_topic_id: main_topic_id,
        topic_id: topicId,
        ai_id: aiID,
        Continue: Boolean(continueValue),
        mapped_skills: [
          {
            label: skillName,
            skill_id: skillId,
            skill_name: skillName,
            value: skillId,
          },
        ],
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          setstoresessionId(data.data[0]?.assessments[0]?.session_id);
          setstoremedalValue(data?.data?.[0]?.assessment_mode || "");
          setstoreassessmentCount(data?.data?.[0]?.assessment_count || 1);
          console.log("medalvalue", storemedalValue);
          setstoresessionTime(data.data[0]?.session_time_taken || 0);
          setElapsedSeconds(data.data[0]?.session_time_taken || 0);
          setthreshold_mark(data?.data?.[0]?.assessments?.[0]?.threshold_marks);
          setPercentMark(data?.data?.[0]?.total_percent || 0);
          settotalmarkscored(data?.data?.total_mark_scored);
          setEasySkip(data?.data?.[0]?.assessments?.[0]?.easy_skip ?? data?.data?.[0]?.easy_skip ?? true);
          setMediumSkip(data?.data?.[0]?.assessments?.[0]?.medium_skip ?? data?.data?.[0]?.medium_skip ?? true);
          setHardSkip(data?.data?.[0]?.assessments?.[0]?.hard_skip ?? data?.data?.[0]?.hard_skip ?? true);
          const modifiedPractices = data.data[0]?.assessments.map(
            (practice, index) => {
              const baseQuestion = {
                ...practice,
                question_no: index + 1,
              };
              if (
                practice.type === "Match the following" ||
                practice.type === "Match the following with image"
              ) {
                return {
                  ...baseQuestion,
                  draggable: "right",
                };
              } else if (practice.type === "multiple choices") {
                const isMultiSelect = practice.answer.length > 1;
                return {
                  ...baseQuestion,
                  isMultiSelect,
                };
              } else if (
                practice.type === "fill in the blanks" ||
                practice.type === "select the answers"
              ) {
                return {
                  ...baseQuestion,
                  question: practice.question.replace(/<\/p>/g, "</p><br/>"),
                };
              }
              return baseQuestion;
            }
          );

          setPractice(modifiedPractices);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        } else {
          setPractice([]);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        }
      });
     } else {
        // If we have no context (e.g. came from Trouble "Practice Again"), don't pass undefined state to /skill/list
        if (aiID && uniqueId) {
          navigate("/skill/list", {
            state: {
              pageNum,
              title,
              uniqueId,
              aiId: aiID,
              main_topic_id,
              topic_id: topicId,
              singleTopic,
              learning,
              mapped,
              mainId,
              topic_no,
              userID,
              orgID,
              fromSubTopic,
              fromNewLearningDetail,
              ...practiceScrollState,
            },
          });
        } else {
          setLoading(false);
          navigate("/new/learnings", { replace: true });
        }
      }
  }

  async function practiceAnswer() {
    const questionId = currentPractice.id ? currentPractice.id.toString() : "";
    let answerToSend;
    if (
      currentPractice.type === "Match the following" ||
      currentPractice.type === "Match the following with image"
    ) {
      if (currentPractice.draggable === "right") {
        answerToSend =
          practiceData[currentPractice.unique_id]?.answers?.right || [];
      } else if (currentPractice.draggable === "left") {
        answerToSend =
          practiceData[currentPractice.unique_id]?.answers?.left || [];
      }
    } else if (currentPractice.type === "cross word puzzle") {
      answerToSend = practiceData[currentPractice.unique_id]?.answers.map(
        (answerGroup) =>
          Array.isArray(answerGroup)
            ? answerGroup.map((answer) => ({
                clueID: answer.clueID,
                clueNumber: answer.clueNumber,
                cluevalue: answer.cluevalue,
              }))
            : answerGroup
      );
    } else if (currentPractice.type === "highlight") {
      const highlightHtml =
        practiceData[currentPractice.unique_id]?.highlightContent || "";
      answerToSend = highlightHtml
        ? [normalizeHighlightAnswerHtml(highlightHtml)]
        : [];
    } else if (currentPractice.type === "highlight_multiple") {
      const uniqueId = currentPractice.unique_id;
      const ranges = practiceData[uniqueId]?.highlightMultipleRange || [];
      const highlightHtml =
        practiceData[uniqueId]?.highlightMultipleContent || "";
      answerToSend = getHighlightMultipleAnswers(ranges, highlightHtml);
    } else if (currentPractice.type === "fill in the blanks") {
    const rawAnswers = practiceData[currentPractice.unique_id]?.answers || [];
    const cleanedAnswers = rawAnswers
      .map((ans) => (typeof ans === "string" ? ans.trim() : ""))
      .filter((ans) => ans !== "");
    const orderedBlanks = [
      ...currentPractice.question.matchAll(/\[blank\s*(\d+)\]/g),
    ].map((m) => m[1]); 
    const sortedBlanks = [...orderedBlanks].sort(
      (a, b) => Number(a) - Number(b)
    ); 
    answerToSend = sortedBlanks.map((num) => {
      const visualIndex = orderedBlanks.indexOf(num);
      return visualIndex >= 0 ? cleanedAnswers[visualIndex] || "" : "";
    });
    } else if (currentPractice.type === "select the answers") {
      const answersObj = practiceData[currentPractice.unique_id]?.answers || {};
      answerToSend =
        Object.values(answersObj).length > 0 ? Object.values(answersObj) : [];
    } else {
      answerToSend = practiceData[currentPractice.unique_id]?.answers || [];
    }

    await fetch(`${baseurl}/assessment/practice-validation`, {
      method: "POST",
      body: JSON.stringify({
        Organization_ID: userDetails && userDetails.org_id,
        topic_id: topicId,
        topic_name: topicName,
        question:
          currentPractice.type === "highlight" ||
          currentPractice.type === "highlight_multiple"
            ? typeof currentPractice.question === "string"
              ? currentPractice.question
              : ""
            : currentPractice.question,
        question_id: questionId,
        answer: answerToSend,
        ai_id: aiID,
        main_topic_id: main_topic_id,
        user_id: userDetails && userDetails._id?.$oid,
        question_type: currentPractice.type,
        case_sensitive:
          currentPractice.type === "fill in the blanks"
            ? currentPractice.case_sensitive ?? false
            : false,
        shuffled_answer:
          currentPractice.type === "fill in the blanks"
            ? currentPractice.shuffled_answer ?? false
            : false,
        options:
          currentPractice.type === "highlight" ||
          currentPractice.type === "highlight_multiple"
            ? Array.isArray(currentPractice.options)
              ? currentPractice.options
              : currentPractice.options
              ? [currentPractice.options]
              : []
            : Array.isArray(currentPractice.options)
            ? currentPractice.options
            : currentPractice.options
            ? [currentPractice.options]
            : [],
        unique_id: currentPractice.unique_id,
        generated_by: currentPractice.generation === "admin" ? "admin" : "",
        left: currentPractice.left ? currentPractice.left : [],
        right: currentPractice.right ? currentPractice.right : [],
        actual_ans:
          currentPractice.type === "cross word puzzle"
            ? currentPractice.options
            : currentPractice.type === "highlight" ||
              currentPractice.type === "highlight_multiple"
            ? Array.isArray(currentPractice?.answer)
              ? currentPractice.answer
              : currentPractice?.answer
              ? [currentPractice.answer]
              : []
            : Array.isArray(currentPractice.answer)
            ? currentPractice.answer
            : currentPractice.answer
            ? [currentPractice.answer]
            : [],
        question_explained:
          currentPractice.type === "highlight" ||
          currentPractice.type === "highlight_multiple"
            ? typeof currentPractice.question_explained === "string"
              ? currentPractice.question_explained
              : ""
            : currentPractice.question_explained,
        time_taken: "",
        markif_correct: currentPractice.mark,
        markif_incorrect: currentPractice.negative_mark,
        session_id: storesessionId,
        session_time_taken: elapsedSeconds,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const isCorrect =
          data?.data?.validation_result[0]?.answer_is === "Correct";
        const newStatus = isCorrect ? "correct" : "incorrect";
        const resultMessage = isCorrect
          ? CORRECT_MESSAGES[correctMsgIndexRef.current % CORRECT_MESSAGES.length]
          : INCORRECT_MESSAGES[incorrectMsgIndexRef.current % INCORRECT_MESSAGES.length];
        if (isCorrect) {
          correctMsgIndexRef.current += 1;
        } else {
          incorrectMsgIndexRef.current += 1;
        }
        let sanitizedExplanation =
          data?.data?.validation_result[0]?.question_explained;
        // Buffer the next question's assessment_count so we don't change
        // the displayed number while showing the current question's answer
        setNextAssessmentCount(data?.data?.assessment_count ?? null);
        setstoremedalValue(data?.data?.assessment_mode);
        setassementStatus(data?.assessment_status);
        settotalsessionTime(data?.data?.session_time_taken);
        setthreshold_mark(data?.data?.threshold_marks);
        setPercentMark(data?.data?.total_percent);
        settotalmarkscored(data?.data?.total_mark_scored);
        setEasySkip(data.data.easy_skip);
        setMediumSkip(data.data.medium_skip);
        setHardSkip(data.data.hard_skip);
        // When server reports completion, switch to simplified Congrats UI
        if (data?.data) {
          setOhDearSumary({
            threshold_marks: data.data.threshold_marks,
            total_mark_scored: data.data.total_mark_scored,
            session_time_taken: data.data.session_time_taken,
            total_score: data.data.total_score,
            total_percent: data.data.total_percent?? 0,

          });
        }
        // if (data?.assessment_status === "completed") {
          // setassessmentcompletedUI(true);
          // setResult(true);
        // }

        if (sanitizedExplanation === "<p><br></p>") {
          sanitizedExplanation = "";
        }
        setWrongAnswerCount((prev) => {
          const newCount = isCorrect ? 0 : prev + 1;
          if (newCount >= 3) setFailedPopup(true);
          return newCount;
        });
        const matchFieldExists =
          data?.data?.validation_result[0]?.match !== undefined;
        const rawIncorrectIndex =
          data.incorrect_index ||
          data.data?.incorrect_index ||
          data.data?.validation_result?.[0]?.incorrect_index ||
          [];
        const normalizedIncorrectIndex =
          currentPractice.type === "highlight_multiple"
            ? normalizeHighlightMultipleRangeIndex(rawIncorrectIndex)
            : rawIncorrectIndex;

        setPracticeData((prev) => ({
          ...prev,
          [currentPractice.unique_id]: {
            ...prev[currentPractice.unique_id],
            status: newStatus,
            resultMessage,
            explanations: sanitizedExplanation,
            answered: true,
            ...(matchFieldExists && {
              match: data.data.validation_result[0].match,
            }),
            actual_ans: data.data.validation_result[0]?.actual_ans,
            left: data.data.validation_result[0]?.left,
            right: data.data.validation_result[0]?.right,
            question_type: data.data.validation_result[0]?.question_type,
            incorrect_index: normalizedIncorrectIndex,
          },
        }));

        // A completed response is the end of this practice session. Show the
        // completed screen immediately instead of waiting for the member to
        // press Next (which is only needed while another question remains).
        if (data?.assessment_status === "completed") {
          setassessmentcompletedUI(true);
          setResult(true);
          return;
        }

        setValidateClicked(true);
        // Append next question from validation response if provided
        const newAssessmentRaw = data?.data?.new_assessment;
        if (newAssessmentRaw) {
          const mapAssessment = (practiceItem, indexOffset) => {
            const baseQuestion = {
              ...practiceItem,
              question_no: indexOffset,
            };
            if (
              practiceItem.type === "Match the following" ||
              practiceItem.type === "Match the following with image"
            ) {
              return {
                ...baseQuestion,
                draggable: "right",
              };
            } else if (practiceItem.type === "multiple choices") {
              const isMultiSelect = (practiceItem.answer || []).length > 1;
              return {
                ...baseQuestion,
                isMultiSelect,
              };
            } else if (
              practiceItem.type === "fill in the blanks" ||
              practiceItem.type === "select the answers"
            ) {
              return {
                ...baseQuestion,
                question: (practiceItem.question || "").replace(
                  /<\/p>/g,
                  "</p><br/>"
                ),
              };
            }
            return baseQuestion;
          };
          setPractice((prev) => {
            const nextIndex = (prev?.length || 0) + 1;
            const mapped = mapAssessment(newAssessmentRaw, nextIndex);
            return [...(prev || []), mapped];
          });
        } else {
          if (data?.assessment_status !== "completed") {
            const isCorrect =
              data?.data?.validation_result[0]?.answer_is === "Correct";
            if (!isCorrect) {
              setPendingOhDear(true);
            }
          }
        }
      })
      .catch((error) => {
        console.error("API call failed:", error);
        setValidateClicked(false);
        setSubmitLoading(false);
        setSubmitError(true); // Fallback for failed request
        // fallback on failure
      });
  }

  async function endPractice() {
    await fetch(`${baseurl}/assement/end-batch-test`, {
      method: "POST",
      body: JSON.stringify({
        learning_id: learning_id || "67061cf7959e5f1628eb5bbd",
        topic_id: Topic.id || "02024071811043711377",
        user_id: userDetails && userDetails._id?.$oid,
        main_topic_id: main_topic_id || "6698f6c55cd20b9546e08da5",
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          setResult(true);
          setSummaryDetail(data.data);
          setCarouselData(data.data?.awards);
          set;
          const coinsArray = data.data?.coins || [];
          const coinsSum = coinsArray.reduce(
            (sum, coin) => sum + Number(coin),
            0
          ); // Ensure coins are converted to numbers
          setPoints(coinsSum);
          setFinishPopup(false);
          setTimeout(() => {
            // Check if awards array exists and is not empty
            if (data.data?.awards && data.data.awards.length > 0) {
              setAchievementPopup(true);
            }
          }, 1000);
        }
      });
  }

  const explanationWithDefaultImageSize = practiceData[
    currentPractice.unique_id
  ]?.explanations.replace(/<img(.*?)>/g, '<img$1 width="200" height="auto">');

  useEffect(() => {
    // Mark browser reloads while on /practice so we can show resume popup on next mount.
    const handleBeforeUnload = () => {
      sessionStorage.setItem(PRACTICE_BROWSER_RELOAD_KEY, "1");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  useEffect(() => {
    // Only show popup when this page was truly reloaded (F5 / refresh),
    // not when navigating to /practice from inside the SPA.
    const isBrowserReload =
      sessionStorage.getItem(PRACTICE_BROWSER_RELOAD_KEY) === "1";
    sessionStorage.removeItem(PRACTICE_BROWSER_RELOAD_KEY);

    if (pageReload && isReloadNav && isBrowserReload) {
      setReloadDecisionPopup(true);
      setResolvedContinueFlag(null);
      setLoading(false);
    } else {
      setResolvedContinueFlag(continueFlag);
    }
    setReloadChecked(true);
  }, [pageReload, isReloadNav, continueFlag]);

  useEffect(() => {
    if (!USERID || !reloadChecked) return;
    if (reloadDecisionPopup) return;
    if (pageReload && resolvedContinueFlag === null) return;
    if (result || ohDearResult) return;
    setLoading(true);
    practiceGet(resolvedContinueFlag);
  }, [USERID, reloadChecked, reloadDecisionPopup, pageReload, resolvedContinueFlag, result, ohDearResult]);

  useEffect(() => {
    if (storesessionTime > 0) {
      setElapsedSeconds(storesessionTime);
    }
  }, [storesessionTime]);

  const handleSelectionChange = (range, oldRange, source) => {
    const quill = quillRef.current.getEditor();
    const uniqueId = currentPractice.unique_id;

    if (range && range.length > 0) {
      const selectedText = quill.getText(range.index, range.length).trim();
      const currentData = practiceData[uniqueId];
      const status = currentData.status;
      const previousRange = currentData.previousRange;
      if (
        previousRange &&
        previousRange.index === range.index &&
        previousRange.length === range.length
      ) {
        quill.formatText(range.index, range.length, "color", false);
        setPracticeData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...currentData,
            previousRange: null,
            lastSelectedText: "",
            highlightContent: quill.root.innerHTML,
          },
        }));
      } else {
        if (previousRange) {
          quill.formatText(
            previousRange.index,
            previousRange.length,
            "color",
            false
          );
        }
        const highlightColor = getHighlightColor(status);
        quill.formatText(range.index, range.length, "color", highlightColor);
        setPracticeData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...currentData,
            previousRange: range,
            lastSelectedText: selectedText,
            highlightContent: quill.root.innerHTML,
          },
        }));
      }
    }
  };

  const handleMultipleSelectionChange = (range, oldRange, source) => {
    const quill = quillRef.current.getEditor();
    const uniqueId = currentPractice.unique_id;

    if (range && range.length > 0) {
      let selectedText = quill.getText(range.index, range.length).trim();
      selectedText = selectedText.endsWith(".")
        ? selectedText.slice(0, -1)
        : selectedText;
      if (!selectedText) return;

      const currentData = practiceData[uniqueId];
      const highlightColor = getHighlightColor(currentData.status);
      const currentRanges = currentData.highlightMultipleRange || [];
      const existingRangeIndex = currentRanges.findIndex(
        (r) => r.index === range.index && r.length === range.length
      );

      if (existingRangeIndex !== -1) {
        quill.formatText(range.index, range.length, "color", false);

        const updatedRanges = [...currentRanges];
        updatedRanges.splice(existingRangeIndex, 1);
        const updatedContent = quill.root.innerHTML;

        setPracticeData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...currentData,
            highlightMultipleRange: updatedRanges,
            highlightMultipleContent: updatedContent,
            answers: getHighlightMultipleAnswers(updatedRanges, updatedContent),
          },
        }));
      } else {
        const overlappingRanges = currentRanges.filter(
          (r) =>
            r.index < range.index + range.length &&
            range.index < r.index + r.length
        );

        let updatedRanges = [...currentRanges];
        overlappingRanges.forEach((overlappingRange) => {
          quill.formatText(
            overlappingRange.index,
            overlappingRange.length,
            "color",
            false
          );

          updatedRanges = updatedRanges.filter(
            (r) =>
              r.index !== overlappingRange.index ||
              r.length !== overlappingRange.length
          );
        });
        quill.formatText(range.index, range.length, "color", highlightColor);
        updatedRanges.push({
          index: range.index,
          length: range.length,
          text: selectedText,
          start: range.index,
          end: range.index + range.length,
        });
        const updatedContent = quill.root.innerHTML;
        setPracticeData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...currentData,
            highlightMultipleRange: updatedRanges,
            highlightMultipleContent: updatedContent,
            answers: getHighlightMultipleAnswers(updatedRanges, updatedContent),
          },
        }));
      }
    }
  };

  const handleQuillChange = (value) => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const container = quill.root.parentElement;
      container.style.border = "none";
      container.style.boxShadow = "none";
    }
    const uniqueId = practice[currentIndex]?.unique_id;
    setPracticeData((prev) => ({
      ...prev,
      [uniqueId]: {
        ...prev[uniqueId],
        highlightContent: value,
      },
    }));
  };

  const handleHighlightMultipleQuillChange = (value) => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const container = quill.root.parentElement;
      container.style.border = "none";
      container.style.boxShadow = "none";
    }
    const uniqueId = practice[currentIndex]?.unique_id;
    setPracticeData((prev) => ({
      ...prev,
      [uniqueId]: {
        ...prev[uniqueId],
        highlightMultipleContent: value,
      },
    }));
  };

  useEffect(() => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const uniqueId = currentPractice.unique_id;
      const status = practiceData[uniqueId]?.status;
      const previousRange = practiceData[uniqueId]?.previousRange;
      const highlightMultipleRange =
        practiceData[uniqueId]?.highlightMultipleRange || [];
      const incorrectRanges =
        currentPractice.type === "highlight_multiple"
          ? normalizeHighlightMultipleRangeIndex(
              practiceData[uniqueId]?.incorrect_index || []
            )
          : [];

      if (quill && status) {
        const highlightColor = getHighlightColor(status);

        if (currentPractice.type === "highlight" && previousRange) {
          quill.formatText(
            previousRange.index,
            previousRange.length,
            "color",
            highlightColor
          );
        }
        if (
          currentPractice.type === "highlight_multiple" &&
          highlightMultipleRange.length > 0 &&
          practiceData[uniqueId]?.answered
        ) {
          const plainText = quill.getText().replace(/\n$/, "");
          highlightMultipleRange.forEach((range) => {
            const isIncorrect = isHighlightMultipleRangeIncorrect(
              range,
              incorrectRanges,
              plainText
            );
            quill.formatText(
              range.index,
              range.length,
              "color",
              isIncorrect ? "rgb(255, 36, 67)" : "rgba(0, 203, 244, 0.5)"
            );
          });
        } else if (
          currentPractice.type === "highlight_multiple" &&
          highlightMultipleRange.length > 0
        ) {
          highlightMultipleRange.forEach((range) => {
            quill.formatText(
              range.index,
              range.length,
              "color",
              highlightColor
            );
          });
        }
      }
    }
  }, [
    practiceData[currentPractice.unique_id]?.status,
    practiceData[currentPractice.unique_id]?.incorrect_index,
    practiceData[currentPractice.unique_id]?.answered,
  ]);

  useEffect(() => {
    if (practice.length > 0) {
      const currentAssmnt = practice[currentIndex];
      const uniqueId = currentAssmnt?.unique_id;

      setCurrentPractice(currentAssmnt);

      if (!practiceData[uniqueId]) {
        let initialAnswers;
        let initialAcrossClues = [];
        let initialDownClues = [];
        let highlightContent = "";
        let lastSelectedText = "";
        let highlightMultipleContent = "";
        let initialRightOrder = [];

        if (
          currentAssmnt.type === "Match the following" ||
          currentAssmnt.type === "Match the following with image"
        ) {
          const filteredLeft = (currentAssmnt.left || []).filter(
            (leftData) => leftData.trim() !== ""
          );
          const filteredRight = (currentAssmnt.right || []).filter(
            (rightData) => rightData.trim() !== ""
          );
          initialAnswers = {
            left: filteredLeft,
            right: filteredRight,
          };
          initialRightOrder = filteredRight.map((_, i) => i);
        } else if (currentAssmnt.type === "Rearrange") {
          initialAnswers = currentAssmnt.options || [];
        } else if (currentAssmnt.type === "cross word puzzle") {
          const grid = currentAssmnt.options.map((row) =>
            row.map((cell) => ({
              clueID: cell.clueID || "",
              clueNumber: cell.clueNumber,
              cluevalue: "",
              disabled: cell.cluevalue === "",
            }))
          );
          initialAnswers = grid;

          initialAcrossClues = currentAssmnt.left.map((clueObj) => ({
            id: clueObj.id,
            number: clueObj.number,
            clue: clueObj.clue,
            answer: "",
          }));
          initialDownClues = currentAssmnt.right.map((clueObj) => ({
            id: clueObj.id,
            number: clueObj.number,
            clue: clueObj.clue,
            answer: "",
          }));
        } else if (currentAssmnt.type === "highlight") {
          // Remove color style from any tag containing `color: rgb(255, 122, 0);`
          highlightContent = currentAssmnt.options.replace(
            /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
            "$1"
          );

          // Remove any remaining <span> tags, if needed
          highlightContent = highlightContent.replace(
            /<span[^>]*>(.*?)<\/span>/g,
            "$1"
          );

          lastSelectedText = "";
        } else if (currentAssmnt.type === "highlight_multiple") {
          highlightMultipleContent = currentAssmnt.options.replace(
            /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
            "$1"
          );

          highlightMultipleContent = highlightMultipleContent.replace(
            /<span[^>]*>(.*?)<\/span>/g,
            "$1"
          );
          initialAnswers = [];
        } else if (currentAssmnt.type === "Drag and Drop" || currentAssmnt.type === "drag and drop_v2") {
          const updatedAnswer = currentAssmnt.answer.map((item) => {
            return {
              ...item,
              values: item.values.map(() => ""),
            };
          });
          initialAnswers = updatedAnswer;
        } else {
          initialAnswers = [];
        }

        setPracticeData((prev) => ({
          ...prev,
          [uniqueId]: {
            answers: initialAnswers,
            rightOrder: initialRightOrder,
            status: "",
            explanations: "",
            cluesAcross: initialAcrossClues,
            cluesDown: initialDownClues,
            highlightContent: highlightContent,
            lastSelectedText: lastSelectedText,
            previousRange: null,
            highlightMultipleContent: highlightMultipleContent,
            highlightMultipleRange: [],
          },
        }));
      } else if (!practiceData[uniqueId]?.status) {
        setPracticeData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...prev[uniqueId],
            status: "viewed",
          },
        }));
      }
    }
  }, [currentIndex, practice, practiceData]);

  useEffect(() => {
    if (currentPractice) {
      if (!inputRefs.current[currentPractice.unique_id]) {
        inputRefs.current[currentPractice.unique_id] = [];
      }
    }
  }, [currentPractice]);

  useEffect(() => {
    const userType =
      userStatus === "succeeded" && userDetails && userDetails.user_type;

    if (userType === "Trail") {
      setTrailUser(true);
    } else {
      setTrailUser(false);
    }
  }, []);

  // Handle outside click for hint dialog
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (hintRef.current && !hintRef.current.contains(event.target)) {
        setHintDialog(false);
        setShowHint(false);
      }
    };

    if (hintDialog) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hintDialog]);

  const handleSubmitLog = async (questionId, questionType, buttonState) => {
    const userId = localStorage.getItem("USERID");
    const logData = {
      question_id: questionId,
      question_type: questionType,
      button_state: buttonState,
      conditions: {
        validateClicked,
        isAlreadyAnswered: practiceData[currentPractice.unique_id]?.answered,
        hasAnswers:
          practiceData[currentPractice.unique_id]?.answers?.length > 0,
      },
    };

    try {
      await fetch(`${baseurl}/submit-log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
        },
        body: JSON.stringify({
          log_data: JSON.stringify(logData),
          log_type: "assesment",
          user_id: userId || "686e114a1513c4e9c5dea500",
          description: "Assesment submit log",
        }),
      });
    } catch (error) {
      console.error("Error submitting log:", error);
    }
  };

  return (
    <div className={style.container}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={levelSkipError}
        sx={{ width: "25rem" }}
        autoHideDuration={3000}
        onClose={() => setlevelSkipError(false)}
      >
        <Alert
          severity="warning"
          variant="filled"
          sx={{ width: "100%", fontSize: "1rem" }}
        >
          skip limit exceeded in {storemedalValue} level
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={error}
        sx={{ width: "25rem" }}
        autoHideDuration={3000}
        onClose={() => {
          setError(false);
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          sx={{ width: "100%", fontSize: "1rem" }}
        >
          Please enter answer..
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackbar.open}
        sx={{ width: "25rem" }}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ open: false, message: "" })}
      >
        <Alert
          severity="warning"
          variant="filled"
          sx={{ width: "100%", fontSize: "1rem" }}
          onClose={() => setSnackbar({ open: false, message: "" })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {submitError && !ohDearResult && (
        <div
          className={style.dearpopupOverlay}
          onClick={() => {
            setOhDearResult(true);
            setResult(true);
            setSubmitError(false);
            EndTest();
          }}
        >
          {/* Stop click bubbling so inside clicks don’t close it */}
          <div className={style.dearPopup} onClick={(e) => e.stopPropagation()}>
            <img className={style.ohDear2} src={ohDear} alt="Person" />
            <div className={style.dearpopupText}>
              <p>Whoops!</p>
            </div>
            <p style={{ textAlign: "center" }}>
              Looks like you’re not quite there yet. Run through the lesson again then pop back here to the Exercise section to practise a few more skills.
            </p>
            {/* <p style={{ textAlign: "center" }}>
              strengthening before you can move forward with the exam
            </p> */}
            <div className={style.dearPopupButton}>
              <button
                className={style.dearYesButton}
                onClick={(e) => {
                  e.preventDefault();
                  const fromLearningPage =
                    fromNewLearningDetail ||
                    fromTroubleFromLearnings ||
                    fromTrouble ||
                    fromTroubleSkill;
                  const fromSubtopicPage =
                    fromTroubleFromSubtopic || fromSubTopic;
                  if (fromSubtopicPage) {
                    if (fromTroubleFromSubtopic && returnToSubtopicState) {
                      getEndSession({
                        pathname: "/subtopic",
                        state: {
                          ...returnToSubtopicState,
                          selectedTab: "all-skills",
                        },
                      });
                    } else {
                      getEndSession({
                        pathname: "/subtopic",
                        state: {
                          aiId: aiID,
                          topicId,
                          topicIndex: topicIndexState,
                          topicValue: topicValueState,
                          moduleName: moduleNameState,
                          moduleIndex: moduleIndexState,
                          selectedTab: "all-skills",
                        },
                      });
                    }
                  } else if (fromLearningPage) {
                    // getEndSession({
                    //   pathname: "/new/learnings/detail",
                    //   state: {
                    //     singleTopic,
                    //     learning,
                    //     mapped,
                    //     mainId,
                    //     topic_no,
                    //     userID,
                    //     orgID,
                    //     ...practiceScrollState,
                    //   },
                    // });
                    getEndSession("/new/learnings");
                  } else {
                    getEndSession("/new/learnings");
                  }
                }}
              >
                Revisit Lesson {">>>"}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={style.practiceSection}>
        <div
          className={style.header}
          style={{ background: trialUser ? "#FF8800" : "" }}
        >
          <div className={style.headerText}>
            {trialUser ? (
              <h5>Trial Test</h5>
            ) : (
              <>
                <div className={style.Container}>
                  <div className={style.topicHeader}>
                    {/* <img
                      src={leftArrow}
                      className={style.backButton}
                      alt="left arrow"
                      onClick={() => navigate("/skill/list", {
                        state: {
                          pageNum,
                          title,
                          uniqueId,
                          aiId: aiID,
                          main_topic_id,
                          topic_id: topicId,
                          singleTopic,
                          learning,
                          mapped,
                          mainId,
                          topic_no,
                          userID,
                          orgID,
                          fromSubTopic,
                          fromNewLearningDetail,
                        }
                      })}
                    /> */}
                    <div className={style.headingP}>
                      <span>
                        {(fromTrouble || fromTroubleSkill)
                          ? "Practice"
                          : `Practice`}
                      </span>
                      <p>
                        {(titleName || titleNameMd || topicName || skillName) || "Practice"} -{" "}
                        <span>{state?.skill_name || skillName}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        {loading && !reloadDecisionPopup ? (
          <Loader />
        ) : (
          <>
            {currentPractice.id ? (
              <div className={style.body}>
                <div className={style.bodyTop}>
                  <div
                    style={{ border: result ? "none" : "" }}
                    className={style.bodyLeft}
                  >
                    {!assessmentcompletedUI && !ohDearResult && (
                      <div className={style.questBox}>
                        <div
                          className={`${style.questionType} ${
                            currentPractice.question_level == "easy"
                              ? style.easy
                              : currentPractice.question_level == "medium"
                              ? style.medium
                              : style.hard
                          }`}
                        >
                          <p className={style.questionTypeP}>
                            {currentPractice.question_level
                              ? currentPractice.question_level
                                  .charAt(0)
                                  .toUpperCase() +
                                currentPractice.question_level.slice(1)
                              : ""}
                          </p>
                        </div>
                      </div>
                    )}

                    {result || ohDearResult ? (
                      <>
                        {assessmentcompletedUI ? (
                          <div className={style.resultSection}>
                            <div className={style.resultSectionHeder}>
                              <h4 style={{ color: "#D09B00" }}>
                                Congratulations!{" "}
                              </h4>
                              <p>
                                Skill acquired: {skillName}
                              </p>
                            </div>
                            <div className={style.resultSectionImage}>
                              <img src={TrophyImage} alt="Winner" />
                            </div>
                          </div>
                        ) : showOhDearPage ? (
                          <div className={style.resultWrapper}>
                            <div className={style.resultLeft}>
                              <div className={style.resultSection}>
                                <div className={style.resultSectionHeder}>
                                  <h4 style={{ color: "#FF2443" }}>Oh dear!</h4>
                                  <span
                                    style={{
                                      color: "#2471ffff",
                                      textAlign: "center",
                                    }}
                                  >
                                    You’re not yet an expert in {skillName}.
                                  </span>
                                </div>

                                <div className={style.resultSectionImage}>
                                  <img src={ohdearimg} alt="oh dear" />
                                </div>

                                <div
                                  className={style.resultSectionBottomContent}
                                >
                                  <p>You scored</p>
                                  <h4>
                                    {percentMark}%
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className={style.resultSection}>
                            {(ohDearResult ||
                              summaryDetail?.percentage !== undefined) && (
                              <>
                                {resultPercentage >= 85 ? (
                                  <>
                                    <div className={style.resultSectionHeder}>
                                      <h4 style={{ color: "#D09B00" }}>
                                        Congratulations!{" "}
                                      </h4>
                                      <p>
                                        Skill acquired: {skillName}
                                      </p>
                                    </div>
                                    <div className={style.resultSectionImage}>
                                      <img src={TrophyImage} alt="Winner" />
                                    </div>
                                  </>
                                ) : resultPercentage >= 60 ? (
                                  <>
                                    <div className={style.resultSectionHeder}>
                                      <h4 style={{ color: "#00CBF4" }}>
                                        Well Done!{" "}
                                      </h4>
                                      {/* <p>
                                        You've performed well in the test. Keep
                                        up the good work.
                                      </p> */}
                                      <p>You performed well in the test.</p>
                                    </div>
                                    <div className={style.resultSectionImage}>
                                      <img
                                        src={SecondTrophyImage}
                                        alt="Winner"
                                      />
                                    </div>
                                  </>
                                ) : resultPercentage >= 40 ? (
                                  <>
                                    <div className={style.resultSectionHeder}>
                                      <h4 style={{ color: "#FF8800" }}>
                                        Nice effort!
                                      </h4>
                                      <p>
                                        There's room for improvement, but you're
                                        on the right track. Keep practicing.
                                      </p>
                                    </div>
                                    <div className={style.resultSectionImage}>
                                      <img
                                        src={ThirdTrophyImage}
                                        alt="Average"
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className={style.resultSectionHeder}>
                                      <h4 style={{ color: "#FF2443" }}>
                                        Don't give up!
                                      </h4>
                                      <p>
                                        With consistent practice, you can
                                        achieve your goals.
                                      </p>
                                    </div>
                                    <div className={style.resultSectionImage}>
                                      <img
                                        src={FourthTrophyImage}
                                        alt="Try Again"
                                      />
                                    </div>
                                  </>
                                )}
                                <div
                                  className={style.resultSectionBottomContent}
                                >
                                  <p>You scored</p>
                                  <h4>
                                    {ohDearResult
                                      ? `${Number(percentMark) || Number(ohDearSummary?.total_percent) || 0}%`
                                      : `${summaryDetail.correct_answers}/${
                                          summaryDetail?.practices_count || 0
                                        }`}
                                  </h4>
                                </div>
                              </>
                            )}
                          </div>
                        )}

                        {!trialUser &&
                        !assessmentcompletedUI &&
                        !ohDearResult ? (
                          <div className={style.resultBottom}>
                            {/* <p>The journey to mastering grammar continues! </p> */}
                            <p>You’re on your way to mastering English grammar!</p>
                            <h4>
                              Let's move on to the next topic and keep
                              improving.
                            </h4>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                navigate("/new/learnings");
                              }}
                            >
                              Choose my next topic &nbsp;{">>"}
                            </button>
                          </div>
                        ) : null}
                        {(assessmentcompletedUI || ohDearResult) && 
                        (
                          <div className={style.resultBottom}>
                            <button style={{width:"180px"}}
                             onClick={handleGoToSkills}
                      // onClick={()=> navigate("/subtopic",
                      //   {
                      //     state:{
                      //       aiId: aiID,
                      //       topicId: topicId,
                      //       topicIndex:topic_no,
                      //       topicValue:title,
                      //       moduleName:titleNameMd,
                      //       moduleIndex:pageNum,
                      //       searchTerm: ""
                      //     }
                      //   }
                      // )}
                            >
                              {(fromTroubleFromLearnings || fromTroubleFromSubtopic || fromTroubleSkill || fromTrouble) ? "Go to trouble spot" : "Go To Skills"}
                            </button>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className={style.questionSection}>
                          <div className={style.question}>
                            <div className={style.questionLeft}>
                              <span>{storeassessmentCount}.</span>
                            </div>
                            <div className={style.questionRight}>
                              <div className={style.questionContainer}>
                                {currentPractice.type ===
                                "fill in the blanks" ? (
                                  <div className={style.inputWrapper}>
                                    {renderQuestionWithInputs(
                                      currentPractice.question
                                    )}
                                  </div>
                                ) : currentPractice.type ===
                                  "select the answers" ? (
                                  <div className={style.dropDownWrapper}>
                                    {renderQuestionWithDropdowns(
                                      currentPractice.question,
                                      currentPractice.options
                                    )}
                                  </div>
                                ) : (
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: currentPractice.question,
                                    }}
                                  ></p>
                                )}
                              </div>
                              <div className={style.questionBody}>
                                {currentPractice.type === "ordinary" ? (
                                  <div className={style.ordinaryContainer}>
                                    <div className={style.ordinarySection}>
                                      <div
                                        className={style.ordinarySectionRight}
                                      >
                                        <input
                                          spellCheck="false"
                                          autoCorrect="off"
                                          autoComplete="off"
                                          disabled={
                                            practiceData[
                                              currentPractice.unique_id
                                            ]?.answered
                                          }
                                          style={{
                                            backgroundColor:
                                              practiceData[
                                                currentPractice.unique_id
                                              ]?.status === "correct"
                                                ? "#00DFC7"
                                                : practiceData[
                                                    currentPractice.unique_id
                                                  ]?.status === "incorrect"
                                                ? "#FF7C8E"
                                                : "transparent",
                                          }}
                                          onChange={(e) => {
                                            const uniqueId =
                                              currentPractice.unique_id;
                                            setPracticeData((prev) => ({
                                              ...prev,
                                              [uniqueId]: {
                                                ...prev[uniqueId],
                                                answers: [e.target.value],
                                              },
                                            }));
                                          }}
                                          value={
                                            practiceData[
                                              currentPractice.unique_id
                                            ]?.answers[0] || ""
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ) : currentPractice.type ===
                                  "multiple choices" ? (
                                  <div
                                    className={style.multipleChoiceContainer}
                                  >
                                    {currentPractice.options
                                      ?.filter(
                                        (option) =>
                                          String(option)
                                            .replace(/<[^>]*>/g, "")
                                            .replace(/&nbsp;/gi, " ")
                                            .trim() !== ""
                                      )
                                      .map((option, index) => {
                                        const selectedIndexes =
                                          selectedOptions[
                                            currentPractice.unique_id
                                          ] || [];
                                        const isSelected =
                                          selectedIndexes.includes(index);
                                        const status =
                                          practiceData[
                                            currentPractice.unique_id
                                          ]?.status;
                                          const actualAnsList =
                                          practiceData[
                                            currentPractice.unique_id
                                          ]?.actual_ans || [];
                                        const userAnswers =
                                          practiceData[
                                            currentPractice.unique_id
                                          ]?.answers || [];
                                          const normalizedOption = option.trim();
                                          const isBlue =
                                            actualAnsList.some(
                                              (ans) => ans.trim() === normalizedOption
                                            ) &&
                                            userAnswers.some(
                                              (ans) => ans.trim() === normalizedOption
                                            );

                                        let optionClass = "";
                                        if (isBlue) {
                                          optionClass = style.blueHighlight;
                                          } else if (isSelected) {
                                          optionClass =
                                            status === "correct"
                                              ? style.correct
                                              : status === "incorrect"
                                              ? style.incorrect
                                              : style.selected;
                                        } else {
                                          optionClass = style.unselected;
                                        }

                                        return (
                                          <div
                                            key={index}
                                            onClick={() => {
                                              if (
                                                practiceData[
                                                  currentPractice.unique_id
                                                ]?.answered !== true
                                              ) {
                                                handleOptionClick(
                                                  option,
                                                  index
                                                );
                                              }
                                            }}
                                            className={`${style.multipleChoiceAnswer} ${optionClass}`}
                                          >
                                            <p
                                              dangerouslySetInnerHTML={{
                                                __html: String(option)
                                                  .replace(/<p>/gi, "")
                                                  .replace(/<\/p>/gi, "")
                                                  .replace(/&nbsp;/g, " "),
                                              }}
                                            />
                                          </div>
                                        );
                                      })}
                                  </div>
                                ) : currentPractice.type ===
                                  "Match the following" ? (
                                  <div
                                    className={style.matchFollowingContainer}
                                  >
                                    <DragDropContext
                                      onDragEnd={handleOnDragEnd}
                                    >
                                      {Array.from({
                                        length: Math.max(
                                          (
                                            practiceData[
                                              currentPractice.unique_id
                                            ]?.answers?.left || []
                                          ).length,
                                          (
                                            practiceData[
                                              currentPractice.unique_id
                                            ]?.answers?.right || []
                                          ).length
                                        ),
                                      }).map((_, i) => {
                                        const leftData =
                                          (practiceData[
                                            currentPractice.unique_id
                                          ]?.answers?.left || [])[i] || "";
                                        const rightData =
                                          (practiceData[
                                            currentPractice.unique_id
                                          ]?.answers?.right || [])[i] || "";

                                        const matchValue =
                                          practiceData[
                                            currentPractice.unique_id
                                          ]?.match?.[i];
                                        let cardClassName;
                                        if (matchValue === "1") {
                                          cardClassName = style.correctCard;
                                        } else if (matchValue === "0") {
                                          cardClassName = style.errorCard;
                                        } else {
                                          cardClassName = style.defaultCard;
                                        }

                                        return (
                                          <React.Fragment key={i}>
                                            <Droppable
                                              droppableId={`left-${i}`}
                                            >
                                              {(provided) => (
                                                <div
                                                  className={
                                                    style.matchFollowingLeft
                                                  }
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}
                                                >
                                                  {leftData && (
                                                    <Draggable
                                                      draggableId={`left-${i}`}
                                                      index={i}
                                                      isDragDisabled={
                                                        currentPractice.draggable ===
                                                          "right" ||
                                                        practiceData[
                                                          currentPractice
                                                            .unique_id
                                                        ]?.answered
                                                      }
                                                    >
                                                      {(provided) => (
                                                        <div
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          className={`${style.matchFollowingCard} ${cardClassName}`}
                                                        >
                                                          <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: leftData,
                                                            }}
                                                          />
                                                        </div>
                                                      )}
                                                    </Draggable>
                                                  )}
                                                  {provided.placeholder}
                                                </div>
                                              )}
                                            </Droppable>

                                            <Droppable
                                              droppableId={`right-${i}`}
                                            >
                                              {(provided) => (
                                                <div
                                                  className={
                                                    style.matchFollowingRight
                                                  }
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}
                                                >
                                                  {rightData && (
                                                    <Draggable
                                                      draggableId={`right-${i}`}
                                                      index={i}
                                                      isDragDisabled={
                                                        currentPractice.draggable ===
                                                          "left" ||
                                                        practiceData[
                                                          currentPractice
                                                            .unique_id
                                                        ]?.answered
                                                      }
                                                    >
                                                      {(provided) => (
                                                        <div
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          className={`${style.matchFollowingCard} ${cardClassName}`}
                                                        >
                                                          <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: rightData,
                                                            }}
                                                          />
                                                        </div>
                                                      )}
                                                    </Draggable>
                                                  )}
                                                  {provided.placeholder}
                                                </div>
                                              )}
                                            </Droppable>
                                          </React.Fragment>
                                        );
                                      })}
                                    </DragDropContext>
                                  </div>
                                ) : currentPractice.type ===
                                  "Match the following with image" ? (
                                  <div
                                    className={style.matchFollowingContainer}
                                  >
                                    <DragDropContext
                                      onDragEnd={handleOnDragEnd}
                                    >
                                      {Array.from({
                                        length: Math.max(
                                          (
                                            practiceData[
                                              currentPractice.unique_id
                                            ]?.answers?.left || []
                                          ).length,
                                          (
                                            practiceData[
                                              currentPractice.unique_id
                                            ]?.answers?.right || []
                                          ).length
                                        ),
                                      }).map((_, i) => {
                                        const leftData =
                                          (practiceData[
                                            currentPractice.unique_id
                                          ]?.answers?.left || [])[i] || "";
                                        const rightData =
                                          (practiceData[
                                            currentPractice.unique_id
                                          ]?.answers?.right || [])[i] || "";

                                        const matchValue =
                                          practiceData[
                                            currentPractice.unique_id
                                          ]?.match?.[i];
                                        let cardClassName;
                                        if (matchValue === "1") {
                                          cardClassName = style.correctCard;
                                        } else if (matchValue === "0") {
                                          cardClassName = style.errorCard;
                                        } else {
                                          cardClassName = style.defaultCard;
                                        }

                                        return (
                                          <React.Fragment key={i}>
                                            <Droppable
                                              droppableId={`left-${i}`}
                                            >
                                              {(provided) => (
                                                <div
                                                  className={
                                                    style.matchFollowingLeft
                                                  }
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}
                                                >
                                                  {leftData && (
                                                    <Draggable
                                                      draggableId={`left-${i}`}
                                                      index={i}
                                                      isDragDisabled={
                                                        currentPractice.draggable ===
                                                          "right" ||
                                                        practiceData[
                                                          currentPractice
                                                            .unique_id
                                                        ]?.answered
                                                      }
                                                    >
                                                      {(provided) => (
                                                        <div
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          className={`${style.matchFollowingImageCard} ${cardClassName}`}
                                                        >
                                                          <img
                                                            src={leftData}
                                                            alt={`Option ${
                                                              i + 1
                                                            }`}
                                                          />
                                                        </div>
                                                      )}
                                                    </Draggable>
                                                  )}
                                                  {provided.placeholder}
                                                </div>
                                              )}
                                            </Droppable>

                                            <Droppable
                                              droppableId={`right-${i}`}
                                            >
                                              {(provided) => (
                                                <div
                                                  className={
                                                    style.matchFollowingRight
                                                  }
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}
                                                >
                                                  {rightData && (
                                                    <Draggable
                                                      draggableId={`right-${i}`}
                                                      index={i}
                                                      isDragDisabled={
                                                        currentPractice.draggable ===
                                                          "left" ||
                                                        practiceData[
                                                          currentPractice
                                                            .unique_id
                                                        ]?.answered
                                                      }
                                                    >
                                                      {(provided) => (
                                                        <div
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          className={`${style.matchFollowingCard} ${cardClassName}`}
                                                        >
                                                          <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: rightData,
                                                            }}
                                                          />
                                                        </div>
                                                      )}
                                                    </Draggable>
                                                  )}
                                                  {provided.placeholder}
                                                </div>
                                              )}
                                            </Droppable>
                                          </React.Fragment>
                                        );
                                      })}
                                    </DragDropContext>
                                  </div>
                                ) : currentPractice.type === "Rearrange" ? (
                                  <DndContext
                                    collisionDetection={closestCenter}
                                    onDragEnd={handleArrangeDragEnd}
                                  >
                                    <SortableContext
                                      items={practiceData[
                                        currentPractice.unique_id
                                      ]?.answers.map(
                                        (_, index) => `option-${index}`
                                      )}
                                      strategy={rectSortingStrategy}
                                      disabled={
                                        practiceData[currentPractice.unique_id]
                                          ?.answered
                                      }
                                    >
                                      <div
                                        className={`${style.reArrangeContainer} ${
                                          currentPractice?.sentence_type
                                            ? style.reArrangeContainerSentence
                                            : ""
                                        }`}
                                      >
                                        {practiceData[
                                          currentPractice.unique_id
                                        ]?.answers.map((option, index) => (
                                          <SortableItem
                                            key={`option-${index}`}
                                            id={`option-${index}`}
                                            option={option}
                                            index={index}
                                            incorrectIndexes={practiceData[currentPractice.unique_id]?.incorrect_index}
                                            isSentenceType={currentPractice?.sentence_type}
                                          />
                                        ))}
                                       {currentPractice?.append_period && (
                                          <p>.</p>
                                        )}
                                      </div>
                                    </SortableContext>

                                    <div className={style.statusMark}>
                                      {practiceData[currentPractice.unique_id]
                                        ?.answered &&
                                        (practiceData[currentPractice.unique_id]
                                          ?.status === "correct" ? (
                                          <FaCheck
                                            style={{ color: "#00DFC7" }}
                                          />
                                        ) : (
                                          <IoMdClose
                                            style={{ color: "#FF7C8E" }}
                                          />
                                        ))}
                                    </div>
                                  </DndContext>
                                ) : currentPractice.type ===
                                  "cross word puzzle" ? (
                                  <div className={style.crossWordContainer}>
                                    <div className={style.crossWordPuzzle}>
                                      {practiceData[
                                        currentPractice.unique_id
                                      ]?.answers.map((row, rowIndex) => (
                                        <div
                                          key={rowIndex}
                                          className={style.row}
                                        >
                                          {row.map((cell, colIndex) => (
                                            <div
                                              key={`${rowIndex}-${colIndex}`}
                                              className={style.cellContainer}
                                            >
                                              {!cell.disabled && (
                                                <input
                                                  autoCorrect="off"
                                                  autoComplete="off"
                                                  spellCheck="false"
                                                  type="text"
                                                  maxLength="1"
                                                  className={style.activeInput}
                                                  value={cell.value}
                                                  onChange={(e) =>
                                                    handleCellValueChange(
                                                      rowIndex,
                                                      colIndex,
                                                      e.target.value,
                                                      cell.clueID,
                                                      cell.clueNumber
                                                    )
                                                  }
                                                  disabled={cell.disabled}
                                                  ref={(el) => {
                                                    if (el) {
                                                      if (
                                                        !inputRefs.current[
                                                          currentPractice
                                                            .unique_id
                                                        ]
                                                      ) {
                                                        inputRefs.current[
                                                          currentPractice.unique_id
                                                        ] = [];
                                                      }
                                                      inputRefs.current[
                                                        currentPractice.unique_id
                                                      ][
                                                        rowIndex *
                                                          (practiceData[
                                                            currentPractice
                                                              .unique_id
                                                          ]?.answers[0]
                                                            ?.length || 0) +
                                                          colIndex
                                                      ] = el;
                                                    }
                                                  }}
                                                />
                                              )}
                                              {cell.clueNumber && (
                                                <div
                                                  className={style.clueNumber}
                                                >
                                                  {cell.clueNumber}
                                                </div>
                                              )}
                                            </div>
                                          ))}
                                        </div>
                                      ))}
                                    </div>
                                    <div className={style.PuzzleQuestion}>
                                      <div className={style.QuestionAcross}>
                                        <h4>Across</h4>
                                        {practiceData[
                                          currentPractice.unique_id
                                        ]?.cluesAcross.map((clueObj, index) => (
                                          <div
                                            key={index}
                                            className={
                                              style.QuestionAcrossInputContainer
                                            }
                                          >
                                            <span>
                                              {clueObj.number}.{clueObj.clue}{" "}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                      <div className={style.QuestionDown}>
                                        <h4>Down</h4>
                                        {practiceData[
                                          currentPractice.unique_id
                                        ]?.cluesDown.map((clueObj, index) => (
                                          <div
                                            key={index}
                                            className={
                                              style.QuestionDownInputContainer
                                            }
                                          >
                                            <span>
                                              {clueObj.number}.{clueObj.clue}{" "}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                ) : currentPractice.type === "Rewrite" ? (
                                  <div className={style.ordinaryContainer}>
                                    <div className={style.ordinarySection}>
                                      <div
                                        className={style.rewriteSectionRight}
                                      >
                                        <textarea
                                          className={style.textareaStyle}
                                          spellCheck="false"
                                          disabled={
                                            practiceData[
                                              currentPractice.unique_id
                                            ]?.answered
                                          }
                                          style={{
                                            backgroundColor:
                                              practiceData[
                                                currentPractice.unique_id
                                              ]?.status === "correct"
                                                ? "#00DFC7"
                                                : practiceData[
                                                    currentPractice.unique_id
                                                  ]?.status === "incorrect"
                                                ? "#FF7C8E"
                                                : "transparent",
                                          }}
                                          rows={1}
                                          onChange={(e) => {
                                            const uniqueId =
                                              currentPractice.unique_id;
                                            const sanitizedValue =
                                              e.target.value
                                                .replace(/[''']/g, "'")
                                                .replace(/["""]/g, '"');
                                            setPracticeData((prev) => ({
                                              ...prev,
                                              [uniqueId]: {
                                                ...prev[uniqueId],
                                                answers: [sanitizedValue],
                                              },
                                            }));
                                          }}
                                          value={
                                            practiceData[
                                              currentPractice.unique_id
                                            ]?.answers[0] || ""
                                          }
                                          onFocus={(e) =>
                                            (e.target.style.border =
                                              "1px solid #FF7A00")
                                          }
                                          onBlur={(e) =>
                                            (e.target.style.border =
                                              "1px solid #898890")
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ) : currentPractice.type === "highlight" ? (
                                  <ReactQuill
                                    disabled={
                                      practiceData[currentPractice.unique_id]
                                        ?.answered
                                    }
                                    ref={quillRef}
                                    value={
                                      practiceData[currentPractice?.unique_id]
                                        ?.highlightContent || ""
                                    }
                                    onChange={handleQuillChange}
                                    onChangeSelection={handleSelectionChange}
                                    modules={{
                                      toolbar: false,
                                    }}
                                    style={{
                                      width: "100%",
                                      maxHeight: "200px",
                                      border: "none !important",
                                      pointerEvents: practiceData[
                                        currentPractice.unique_id
                                      ]?.answered
                                        ? "none"
                                        : "auto", // Disable mouse interactions
                                      userSelect: practiceData[
                                        currentPractice.unique_id
                                      ]?.answered
                                        ? "none"
                                        : "text", // Disable text selection
                                    }}
                                    readOnly={true}
                                    className={style.customQuill}
                                  />
                                ) : currentPractice.type ===
                                  "highlight_multiple" ? (
                                  <ReactQuill
                                    disabled={
                                      practiceData[currentPractice.unique_id]
                                        ?.answered
                                    }
                                    ref={quillRef}
                                    value={
                                      practiceData[currentPractice?.unique_id]
                                        ?.highlightMultipleContent || ""
                                    }
                                    onChange={
                                      handleHighlightMultipleQuillChange
                                    }
                                    onChangeSelection={
                                      handleMultipleSelectionChange
                                    }
                                    modules={{
                                      toolbar: false,
                                    }}
                                    style={{
                                      width: "100%",
                                      maxHeight: "200px",
                                      border: "none !important",
                                      pointerEvents: practiceData[
                                        currentPractice.unique_id
                                      ]?.answered
                                        ? "none"
                                        : "auto", // Disable mouse interactions
                                      userSelect: practiceData[
                                        currentPractice.unique_id
                                      ]?.answered
                                        ? "none"
                                        : "text", // Disable text selection
                                    }}
                                    readOnly={true}
                                    className={style.customQuill}
                                  />
                                ) : currentPractice.type === "Drag and Drop" ? (
                                  (() => {
                                    const dragDropId =
                                      currentPractice.unique_id;
                                    const dragDropAnswered =
                                      practiceData[dragDropId]?.answered;
                                    const dragDropIncorrectIndexes =
                                      practiceData[dragDropId]
                                        ?.incorrect_index || [];

                                    return (
                                  <div className={style.dragContainer}>
                                    <div
                                      className={`${style.dragOptionContainer} ${
                                        currentPractice?.sentence_type
                                          ? style.dragOptionContainerSentence
                                          : ""
                                      }`}
                                    >
                                      {currentPractice.options
                                        ?.filter(
                                          (option) => option.trim() !== ""
                                        )
                                        .map((option, index) => {
                                          return (
                                            <div
                                              key={index}
                                              className={`${style.dragCard} ${
                                                currentPractice?.sentence_type
                                                  ? style.dragCardSentence
                                                  : ""
                                              }`}
                                              draggable={!dragDropAnswered}
                                              onDragStart={(event) =>
                                                !dragDropAnswered &&
                                                handleDragStart(event, option)
                                              }
                                            >
                                              <p dangerouslySetInnerHTML={{ __html: option }}></p>
                                            </div>
                                          );
                                        })}
                                    </div>
                                    <div className={style.dragTable}>
                                      <table className={style.table}>
                                        <thead>
                                          <tr>
                                            {practiceData[
                                              dragDropId
                                            ]?.answers.map((col, colIndex) => (
                                              <th
                                                key={colIndex}
                                                className={style.tableHeader}
                                              >
                                                {col.header || " "}
                                              </th>
                                            ))}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {renderDragDropTableBody({
                                            columns:
                                              practiceData[dragDropId]
                                                ?.answers,
                                            answered: dragDropAnswered,
                                            incorrectIndexes:
                                              dragDropIncorrectIndexes,
                                            sentenceType:
                                              currentPractice?.sentence_type,
                                            onDragOver: handleDragOver,
                                            onDrop: handleDrop,
                                            onDelete: handleDeleteDroppedCell,
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                    );
                                  })()
                                ) : currentPractice.type === "drag and drop_v2" ? (
                                  (() => {
                                    const dragDropId = currentPractice.unique_id;
                                    const dragDropAnswered = practiceData[dragDropId]?.answered;
                                    const dragDropIncorrectIndexes = practiceData[dragDropId]?.incorrect_index || [];
                                    const answers = practiceData[dragDropId]?.answers || [];
                                    let sentences = [];
                                    if (currentPractice.left && currentPractice.left.length > 0) {
                                      sentences = currentPractice.left;
                                    } else if (currentPractice.paragraphs && currentPractice.paragraphs.length > 0) {
                                      sentences = currentPractice.paragraphs;
                                    } else if (currentPractice.options) {
                                      if (Array.isArray(currentPractice.options)) {
                                        sentences = currentPractice.options;
                                      } else if (typeof currentPractice.options === "string") {
                                        sentences = currentPractice.options.split(/<br\s*\/?>|\n/gi).filter(Boolean);
                                      }
                                    }
                                    const placedWords = answers.flatMap((col) => col.values || []).filter(Boolean);

                                    return (
                                      <div className={style.dragContainer}>
                                        <div className={style.sentencesContainerV2}>
                                          {sentences.map((sentence, sIdx) => {
                                            const parts = parseSentence(sentence);
                                            return (
                                              <p key={sIdx} className={style.sentenceTextV2}>
                                                {parts.map((part, pIdx) => {
                                                  if (part.isDraggable) {
                                                    const isPlaced = placedWords.some(
                                                      (pw) => pw.trim().toLowerCase() === part.word.trim().toLowerCase()
                                                    );
                                                    return (
                                                      <span
                                                        key={pIdx}
                                                        className={isPlaced ? style.draggableWordPlaced : style.draggableWord}
                                                        draggable={!dragDropAnswered && !isPlaced}
                                                        onDragStart={(event) => {
                                                          if (!dragDropAnswered && !isPlaced) {
                                                            handleDragStart(event, part.word);
                                                          }
                                                        }}
                                                      >
                                                        {part.word}
                                                      </span>
                                                    );
                                                  }
                                                  return <span key={pIdx} dangerouslySetInnerHTML={{ __html: part.text }} />;
                                                })}
                                              </p>
                                            );
                                          })}
                                        </div>

                                        <div className={style.dragTable}>
                                          <table className={style.dragTableV2}>
                                            <thead>
                                              <tr>
                                                {answers.map((col, colIndex) => (
                                                  <th
                                                    key={colIndex}
                                                    className={style.dragTableHeaderV2}
                                                  >
                                                    {col.header || " "}
                                                  </th>
                                                ))}
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {renderDragDropTableBodyV2({
                                                columns: answers,
                                                answered: dragDropAnswered,
                                                incorrectIndexes: dragDropIncorrectIndexes,
                                                onDelete: (colIdx, rowIdx) =>
                                                  handleDeleteDroppedCellV2(colIdx, rowIdx, dragDropId),
                                                uniqueId: dragDropId,
                                              })}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    );
                                  })()
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className={style.questionButtonSection}>
                                <div className={style.questionButtonLeft}>
                                  {/* {currentPractice.type === "highlight" &&(
                                    <span>
                                      *Select the text you want to highlight.
                                    </span>
                                  )}
                                  {currentPractice.type === "highlight_multiple" &&(
                                    <span>
                                      *Select all the text you think is correct.
                                    </span>
                                  )} */}
                                  {currentPractice.type === "Match the following" &&(
                                    <span>
                                      *Drag the boxes on the right to drop them next to
                                      the correct match on the left.
                                    </span>
                                  )}
                                  {currentPractice.type === "Drag and Drop" && (
                                    <span>
                                      *Drag each item and drop it into the correct position.
                                    </span>
                                  )}
                                  {currentPractice.type === "drag and drop_v2" && (
                                    <span>
                                      *Drag each underlined word and drop it into the correct category box.
                                    </span>
                                  )}
                                </div>
                                <div className={style.questionButtonRight}>
                                  {practiceData[currentPractice.unique_id]
                                    ?.answered || submitLoading ? (
                                    ""
                                  ) : (
                                    <div className={style.btnGrp}>
                                      <button
                                      disabled={
                                        (storemedalValue === "easy" && !easySkip) ||
                                        (storemedalValue === "medium" && !mediumSkip) ||
                                        (storemedalValue === "hard" && !hardSkip)
                                      }
                                      className={`${style.skipButtonP} ${
                                        (storemedalValue === "easy" && !easySkip) ||
                                        (storemedalValue === "medium" && !mediumSkip) ||
                                        (storemedalValue === "hard" && !hardSkip)
                                          ? style.skipButtonDisabled
                                          : ""
                                      }`}
                                        onClick={() => {
                                          handleSkip();
                                        }}
                                      >
                                        Skip
                                      </button>
                                      {currentPractice?.hint && (
                                        <div className={style.hintContainer}>
                                          {!showHint ? (
                                            <img
                                              src={HintImage}
                                              alt="hint"
                                              className={style.hintImage}
                                              onClick={() => {
                                                setShowHint(true);
                                                setHintDialog(true);
                                              }}
                                            />
                                          ) : (
                                            <div className={style.hintActiveContainer} ref={hintRef}>
                                              <img
                                                src={HintImage2}
                                                alt="hint active"
                                                className={style.hintImage2}
                                                onClick={() => {
                                                  setShowHint(false);
                                                  setHintDialog(false);
                                                }}
                                              />
                                              {hintDialog && (
                                                <div className={style.hintDialog}>
                                                  <div className={style.hintDialogContent}>
                                                    {currentPractice?.hint}
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      )}


                                    </div>
                                  )}

                                  {practiceData[currentPractice.unique_id]
                                    ?.answered ? (
                                    <>
                                      <button
                                        onClick={() => handleNext()}
                                        style={{ background: "#00CBF480" }}
                                      >
                                        Next
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      onClick={() => {
                                        const uniqueId =
                                          currentPractice.unique_id;
                                        const answers =
                                          practiceData[uniqueId]?.answers || [];
                                        const isAlreadyAnswered =
                                          practiceData[uniqueId]?.answered;

                                        handleSubmitLog(
                                          currentPractice.id,
                                          currentPractice.type,
                                          {
                                            validateClicked,
                                            isAlreadyAnswered,
                                            hasAnswers: answers.length > 0,
                                          }
                                        );

                                        setSubmitLoading(true);

                                        if (
                                          validateClicked ||
                                          isAlreadyAnswered
                                        ) {
                                          return;
                                        }

                                        if (
                                          currentPractice.type ===
                                            "Match the following" ||
                                          currentPractice.type ===
                                            "Match the following with image"
                                        ) {
                                          const rightOrder =
                                            practiceData[uniqueId]
                                              ?.rightOrder ||
                                            (answers?.right || []).map(
                                              (_, i) => i
                                            );

                                          // Track by original position, not text value
                                          const areRightAnswersSame =
                                            rightOrder.length === 0 ||
                                            rightOrder.every(
                                              (pos, index) => pos === index
                                            );

                                          if (areRightAnswersSame) {
                                            setError(true);
                                            setSubmitLoading(false);
                                            return;
                                          } else {
                                            practiceAnswer();
                                            setValidateClicked(true);
                                            setSubmitLoading(true);
                                          }
                                        } else if (
                                          currentPractice.type === "Rearrange"
                                        ) {
                                          const options =
                                            currentPractice.options.filter(
                                              (op) => op.trim() !== ""
                                            ) || [];
                                          const areAnswersSame =
                                            options.length === answers.length &&
                                            options.every(
                                              (value, index) =>
                                                value === answers[index]
                                            );
                                          if (areAnswersSame) {
                                            setError(true);
                                            setSubmitLoading(false);
                                            return;
                                          } else {
                                            practiceAnswer();
                                            setValidateClicked(true);
                                            setSubmitLoading(true);
                                          }
                                        } else if (
                                          currentPractice.type === "highlight"
                                        ) {
                                          if (
                                            practiceData[uniqueId]
                                              ?.lastSelectedText === ""
                                          ) {
                                            setError(true);
                                            setSubmitLoading(false);
                                          } else {
                                            practiceAnswer();
                                            setValidateClicked(true);
                                            setSubmitLoading(true);
                                          }
                                        } else if (
                                          currentPractice.type ===
                                          "highlight_multiple"
                                        ) {
                                          const highlightRanges =
                                            practiceData[uniqueId]
                                              ?.highlightMultipleRange || [];
                                          if (highlightRanges.length === 0) {
                                            setError(true);
                                            setSubmitLoading(false);
                                          } else {
                                            practiceAnswer();
                                            setValidateClicked(true);
                                            setSubmitLoading(true);
                                          }
                                        } else if (
                                          currentPractice.type ===
                                          "select the answers"
                                        ) {
                                          // Check if all dropdowns are answered
                                          const unansweredDropdownIds =
                                            currentPractice.options
                                              .map((option) => option.id)
                                              .filter(
                                                (dropdownId) =>
                                                  !(
                                                    answers[dropdownId] &&
                                                    answers[dropdownId].trim() !==
                                                      ""
                                                  )
                                              );

                                          if (unansweredDropdownIds.length > 0) {
                                            setUnansweredSelectDropdowns(
                                              unansweredDropdownIds
                                            );
                                            setError(true);
                                            setSubmitLoading(false);
                                            return;
                                          }
                                          setUnansweredSelectDropdowns([]);
                                          practiceAnswer();
                                          setValidateClicked(true);
                                        } else if (
                                          currentPractice.type ===
                                            "Drag and Drop" ||
                                          currentPractice.type === "drag and drop_v2"
                                        ) {
                                          const hasAtLeastOneAnswer =
                                            answers.some((col) =>
                                              col.values.some(
                                                (value) => value.trim() !== ""
                                              )
                                            );

                                          if (!hasAtLeastOneAnswer) {
                                            setError(true);
                                            setSubmitLoading(false);
                                            return;
                                          } else {
                                            practiceAnswer();
                                            setValidateClicked(true);
                                            setSubmitLoading(true);
                                          }
                                        } else if (answers.length > 0) {
                                          practiceAnswer();
                                          setValidateClicked(true);
                                        } else {
                                          setError(true);
                                          setSubmitLoading(false);
                                        }
                                      }}
                                    >
                                      Submit
                                    </button>
                                  )}
                                </div>
                              </div>
                              {practiceData[currentPractice.unique_id]
                                ?.answered ? (
                                <div className={style.explanationSection}>
                                  <div className={style.resultText}>
                                    <p
                                      style={{
                                        color:
                                          practiceData[
                                            currentPractice.unique_id
                                          ]?.status === "correct"
                                            ? "#00DFC7"
                                            : "#FF2443",
                                      }}
                                    >
                                      {practiceData[currentPractice.unique_id]
                                        ?.resultMessage ||
                                        (practiceData[currentPractice.unique_id]
                                          ?.status === "correct"
                                          ? CORRECT_MESSAGES[0]
                                          : INCORRECT_MESSAGES[0])}
                                    </p>
                                  </div>
                                  {practiceData[currentPractice.unique_id]
                                    ?.answered &&
                                  practiceData[currentPractice.unique_id]
                                    ?.status === "incorrect" &&
                                  practiceData[currentPractice.unique_id]
                                    ?.actual_ans.length > 0 ? (
                                    <>
                                      <div
                                        className={style.correctAnswerHeading}
                                      >
                                        <p>Answer:</p>
                                      </div>
                                      {practiceData[currentPractice.unique_id]
                                        ?.question_type ===
                                        "Match the following" &&
                                      practiceData[currentPractice.unique_id]
                                        ?.left &&
                                      practiceData[currentPractice.unique_id]
                                        ?.left.length > 0 ? (
                                        <div className={style.answerBodyMatch}>
                                          {Array.from({
                                            length: Math.max(
                                              practiceData[
                                                currentPractice.unique_id
                                              ]?.left.length,
                                              practiceData[
                                                currentPractice.unique_id
                                              ]?.actual_ans.length
                                            ),
                                          }).map((_, index) => {
                                            const leftItem =
                                              practiceData[
                                                currentPractice.unique_id
                                              ]?.left[index] || "";
                                            const rightItem =
                                              practiceData[
                                                currentPractice.unique_id
                                              ]?.actual_ans[index] || "";

                                            return (
                                              <div
                                                key={index}
                                                className={style.matchRow}
                                              >
                                                {leftItem && (
                                                  <div
                                                    className={
                                                      style.matchRowCardLeft
                                                    }
                                                  >
                                                    <p
                                                      dangerouslySetInnerHTML={{
                                                        __html: leftItem,
                                                      }}
                                                    />
                                                  </div>
                                                )}
                                                {rightItem && (
                                                  <div
                                                    className={
                                                      style.matchRowCardRight
                                                    }
                                                  >
                                                    <p
                                                      dangerouslySetInnerHTML={{
                                                        __html: rightItem,
                                                      }}
                                                    />
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      ) : practiceData[
                                          currentPractice.unique_id
                                        ]?.question_type ===
                                        "fill in the blanks" ? (
                                        <div>
                                          {practiceData[
                                            currentPractice.unique_id
                                          ]?.actual_ans ? (
                                            renderFillBlankQuestionWithAnswer(
                                              currentPractice.question,
                                              practiceData[
                                                currentPractice.unique_id
                                              ]?.actual_ans
                                            )
                                          ) : (
                                            <p>No correct answers available</p>
                                          )}
                                        </div>
                                      ) : practiceData[
                                          currentPractice.unique_id
                                        ]?.question_type ===
                                          "Match the following with image" &&
                                        practiceData[currentPractice.unique_id]
                                          ?.left &&
                                        practiceData[currentPractice.unique_id]
                                          ?.left.length > 0 ? (
                                        <div className={style.answerBodyMatch}>
                                          {Array.from({
                                            length: Math.max(
                                              practiceData[
                                                currentPractice.unique_id
                                              ]?.left.length,
                                              practiceData[
                                                currentPractice.unique_id
                                              ]?.actual_ans.length
                                            ),
                                          }).map((_, index) => {
                                            const leftItem =
                                              practiceData[
                                                currentPractice.unique_id
                                              ]?.left[index] || "";
                                            const rightItem =
                                              practiceData[
                                                currentPractice.unique_id
                                              ]?.actual_ans[index] || "";
                                            return (
                                              <div
                                                key={index}
                                                className={style.matchRow}
                                              >
                                                {leftItem && (
                                                  <div
                                                    className={
                                                      style.matchRowImageCard
                                                    }
                                                  >
                                                    <img
                                                      src={leftItem}
                                                      alt={`Answer ${
                                                        index + 1
                                                      }`}
                                                      width="200px"
                                                    />
                                                  </div>
                                                )}
                                                {rightItem && (
                                                  <div
                                                    className={
                                                      style.matchRowCardRight
                                                    }
                                                  >
                                                    <p
                                                      dangerouslySetInnerHTML={{
                                                        __html: rightItem,
                                                      }}
                                                    />
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      ) : practiceData[
                                          currentPractice.unique_id
                                        ]?.question_type ===
                                          "select the answer" ||
                                        practiceData[
                                          currentPractice.unique_id
                                        ]?.question_type ===
                                        "select the answers" ? (
                                        <div>
                                          {(
                                            practiceData[
                                              currentPractice.unique_id
                                            ]?.actual_ans || []
                                          ).flat().length > 0 ? (
                                            renderSelectAnswersQuestionWithAnswer(
                                              currentPractice.question,
                                              (
                                                practiceData[
                                                  currentPractice.unique_id
                                                ]?.actual_ans || []
                                              ).flat()
                                            )
                                          ) : (
                                            <p>No correct answers available</p>
                                          )}
                                        </div>
                                      ) : practiceData[
                                          currentPractice.unique_id
                                        ]?.question_type === "Rearrange" ? (
                                        <div>
                                          {practiceData[
                                            currentPractice.unique_id
                                          ]?.actual_ans.length > 0 ? (
                                            <div>
                                              {practiceData[
                                                currentPractice.unique_id
                                              ]?.actual_ans[0] &&
                                              Array.isArray(
                                                practiceData[
                                                  currentPractice.unique_id
                                                ]?.actual_ans[0]
                                              ) &&
                                              practiceData[
                                                currentPractice.unique_id
                                              ]?.actual_ans[0][0] &&
                                              typeof practiceData[
                                                currentPractice.unique_id
                                              ]?.actual_ans[0][0] ===
                                              "object" ? (
                                                <div
                                                  className={`${style.reArrangeContainer} ${
                                                    currentPractice?.sentence_type
                                                      ? style.reArrangeContainerSentence
                                                      : ""
                                                  }`}
                                                >
                                                  {Object.entries(
                                                    practiceData[
                                                      currentPractice.unique_id
                                                    ].actual_ans[0][0]
                                                  )
                                                    .sort(
                                                      ([a], [b]) =>
                                                        Number(a) - Number(b)
                                                    )
                                                    .map(([key, value]) => (
                                                      <div
                                                        key={key}
                                                        className={`${style.reArrangeAnswerCard} ${
                                                          currentPractice?.sentence_type
                                                            ? style.reArrangeAnswerCardSentence
                                                            : ""
                                                        }`}
                                                      >
                                                        <p
                                                          dangerouslySetInnerHTML={{
                                                            __html: String(
                                                              value ?? ""
                                                            )
                                                              .replace(
                                                                /<p>/gi,
                                                                ""
                                                              )
                                                              .replace(
                                                                /<\/p>/gi,
                                                                ""
                                                              )
                                                              .replace(
                                                                /&nbsp;/g,
                                                                " "
                                                              ),
                                                          }}
                                                        />
                                                      </div>
                                                    ))}
                                                    {currentPractice?.append_period && ( <p>.</p> )}
                                                </div>
                                              ) : null}
                                            </div>
                                          ) : (
                                            <p>No correct answers available</p>
                                          )}
                                        </div>
                                        ) : practiceData[
                                          currentPractice.unique_id
                                        ]?.question_type === "highlight" ||
                                        practiceData[
                                          currentPractice.unique_id
                                        ]?.question_type === "highlight_multiple" ? (
                                        <div>
                                          {renderHighlightQuestionWithAnswer(
                                            currentPractice.options ||
                                              currentPractice.question ||
                                              "",
                                              practiceData[currentPractice.unique_id]
                                              ?.actual_ans || []
                                          )}
                                        </div>
                                      ) : practiceData[
                                          currentPractice.unique_id
                                        ]?.question_type ===
                                        "cross word puzzle" ? (
                                        <div>
                                          <p
                                            style={{
                                              textDecoration: "underLine",
                                            }}
                                          >
                                            Across
                                          </p>
                                          {practiceData[
                                            currentPractice.unique_id
                                          ]?.left.length > 0 ? (
                                            <div>
                                              {practiceData[
                                                currentPractice.unique_id
                                              ]?.left.map((value, i) => (
                                                <p key={i}>
                                                  {value.number}.{value.answer}
                                                </p>
                                              ))}
                                            </div>
                                          ) : (
                                            <p>No correct answers available</p>
                                          )}
                                          <p
                                            style={{
                                              textDecoration: "underLine",
                                            }}
                                          >
                                            Down
                                          </p>
                                          {practiceData[
                                            currentPractice.unique_id
                                          ]?.right.length > 0 ? (
                                            <div>
                                              {practiceData[
                                                currentPractice.unique_id
                                              ]?.right.map((value, i) => (
                                                <p key={i}>
                                                  {value.number}.{value.answer}
                                                </p>
                                              ))}
                                            </div>
                                          ) : (
                                            <p>No correct answers available</p>
                                          )}
                                        </div>
                                      ) : practiceData[
                                          currentPractice.unique_id
                                        ]?.question_type === "Drag and Drop" ? (
                                        <div className={style.dragContainer}>
                                          <div className={style.dragTable}>
                                            <table className={style.table}>
                                              <thead>
                                                <tr>
                                                  {practiceData[
                                                    currentPractice.unique_id
                                                  ]?.actual_ans.map(
                                                    (col, colIndex) => (
                                                      <th
                                                        key={colIndex}
                                                        className={
                                                          style.tableHeader
                                                        }
                                                      >
                                                        {col.header || " "}
                                                      </th>
                                                    )
                                                  )}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {renderDragDropTableBody({
                                                  columns:
                                                    practiceData[
                                                      currentPractice
                                                        .unique_id
                                                    ]?.actual_ans,
                                                  answered: false,
                                                  incorrectIndexes: [],
                                                  sentenceType:
                                                    currentPractice?.sentence_type,
                                                })}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      ) : practiceData[
                                          currentPractice.unique_id
                                        ]?.question_type === "drag and drop_v2" ? (
                                        (() => {
                                          let sentences = [];
                                          if (currentPractice.left && currentPractice.left.length > 0) {
                                            sentences = currentPractice.left;
                                          } else if (currentPractice.paragraphs && currentPractice.paragraphs.length > 0) {
                                            sentences = currentPractice.paragraphs;
                                          } else if (currentPractice.options) {
                                            if (Array.isArray(currentPractice.options)) {
                                              sentences = currentPractice.options;
                                            } else if (typeof currentPractice.options === "string") {
                                              sentences = currentPractice.options.split(/<br\s*\/?>|\n/gi).filter(Boolean);
                                            }
                                          }
                                          return (
                                            <div className={style.dragContainer}>
                                              <div className={style.dragTable}>
                                                <table className={style.dragTableV2}>
                                                  <thead>
                                                    <tr>
                                                      {practiceData[
                                                        currentPractice.unique_id
                                                      ]?.actual_ans.map(
                                                        (col, colIndex) => (
                                                          <th
                                                            key={colIndex}
                                                            className={
                                                              style.dragTableHeaderV2
                                                            }
                                                          >
                                                            {col.header || " "}
                                                          </th>
                                                        )
                                                      )}
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {renderDragDropTableBodyV2({
                                                      columns:
                                                        practiceData[
                                                          currentPractice
                                                            .unique_id
                                                        ]?.actual_ans,
                                                      answered: false,
                                                      incorrectIndexes: [],
                                                      uniqueId: currentPractice.unique_id,
                                                    })}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          );
                                        })()
                                      ) : practiceData[
                                          currentPractice.unique_id
                                        ]?.actual_ans &&
                                        practiceData[currentPractice.unique_id]
                                          ?.actual_ans.length > 0 ? (
                                        <div>
                                          {practiceData[
                                            currentPractice.unique_id
                                          ]?.actual_ans.map(
                                            (answer, answerIndex) => (
                                              <p
                                                key={answerIndex}
                                                dangerouslySetInnerHTML={{
                                                  __html: String(answer ?? "")
                                                    .replace(/<p>/gi, "")
                                                    .replace(/<\/p>/gi, "")
                                                    .replace(/&nbsp;/g, " "),
                                                }}
                                              />
                                            )
                                          )}
                                        </div>
                                      ) : (
                                        <p>No answers available</p>
                                      )}
                                    </>
                                  ) : (
                                    ""
                                  )}

                                  {practiceData[currentPractice.unique_id]
                                    ?.answered &&
                                  practiceData[
                                    currentPractice.unique_id
                                  ]?.explanations?.trim() &&
                                  practiceData[
                                    currentPractice.unique_id
                                  ]?.explanations
                                    .replace(/<[^>]*>/g, "")
                                    .trim() ? (
                                    <>
                                      <div className={style.explanationHeading}>
                                        <p>Explanation:</p>
                                      </div>
                                      <div className={style.explanationText}>
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              explanationWithDefaultImageSize,
                                          }}
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className={style.bodyRight}>
                    {result || ohDearResult ? (
                      <div className={style.summeryContainer}>
                        {/* Percentage Score Section */}
                        <div className={style.percentageSection}>
                          <div className={style.circularProgressbar}>
                            <div
                              className={style.progressRing}
                              style={{
                                background: showOhDearPage
                                  ? "conic-gradient(#FFA500 0deg, #FFA500 360deg, #f0f0f0 360deg)"
                                  : "conic-gradient(#00DFC7 0deg, #00DFC7 360deg, #f0f0f0 360deg)",
                              }}
                            >
                              <div className={style.progressText}>
                          {ohDearResult ? (
                            ohDearSummary?.threshold_marks > 0 ? (
                              `${(ohDearSummary?.total_percent)}%`
                            ) : (
                              "0%"
                            )
                          ) : endSession?.threshold_marks > 0 ? (
                            isNaN(
                              (endSession.total_mark_scored / endSession.threshold_marks) * 100
                            ) ? (
                              "0%"
                            ) : (
                              `${(
                                (endSession.total_mark_scored / endSession.threshold_marks) *
                                100
                              ).toFixed(0)}%`
                            )
                          ) : (
                            `${isNaN(summaryDetail?.percentage) ? 100 : summaryDetail?.percentage}%`
                          )}
                        </div>
                            </div>
                          </div>
                          <div className={style.percentageLabel}>
                            % of marks acquired
                          </div>
                        </div>

                        {/* Separator Line */}
                        <div className={style.separatorLine}></div>

                        {/* Total Time Taken Section */}
                        <div className={style.timeSection}>
                          <div className={style.timeLabel}>
                            Total time taken
                          </div>
                          <div className={style.timeDisplay}>
                            {(ohDearResult
                              ? formatTime(
                                  Number(ohDearSummary?.session_time_taken) || 0
                                )
                              : formatTime(Number(totalsessionTime) || 0)
                            )
                              .split("")
                              .map((char, idx) =>
                                char === ":" ? (
                                  <div
                                    key={`colon-${idx}`}
                                    className={style.timeColon}
                                  >
                                    :
                                  </div>
                                ) : (
                                  <div
                                    key={`digit-${idx}`}
                                    className={style.timeDigit}
                                  >
                                    {char}
                                  </div>
                                )
                              )}
                          </div>
                        </div>
                        <div className={style.separatorLine}></div>
                              <div className={style.mainImageDiv}>
                            <div className={style.imageDiv}>
                              {percentMark >= 60 ?
                              (<img className={style.lockImage2} src={bronze} alt="Easy Medal" />)
                              : (<img className={style.lockImage2} src={bronzelocked} alt="Easy Medal" /> )}
                            </div>

                            <div className={style.imageDiv} >
                              {percentMark >= 80 ?
                                <img className={style.lockImage2} src={sliverrank} alt="Medium Medal" />
                                : <img className={style.lockImage2} src={silverlocked} alt="Medium Medal" />
                              }
                              </div>
                           <div className={style.imageDiv}>
                              {percentMark >= 100 ? 
                              <img className={style.lockImage2} src={goldrank} alt="Hard Medal" />
                              : <img className={style.lockImage2} src={goldlocked} alt="Hard Medal" />
                              }
                            </div>
                          </div>
                      </div>
                    ) : (
                      <>
                        <div className={style.markContainer}>
                          <div className={style.practiceTimer}>
                            <p>{formatTime(elapsedSeconds)}</p>
                          </div>
                          <div className={style.markData}>
                            <div className={style.markDataLeft}>
                              <p>Marks scored:</p>
                            </div>
                            <div
                              style={{ marginBottom: "8px" }}
                              className={style.markDataRight}
                            >
                              <p>
                                <span>
                                  {percentMark} %
                                </span>
                              </p>
                            </div>
                          </div>
                          {/* <div className={style.markData}>
                            <div className={style.markDataLeft}>
                              <p>Negative marks: </p>
                            </div>
                            <div className={style.markDataRight}>
                              <p>{currentPractice.negative_mark}</p>
                            </div>
                          </div> */}
                          <div className={style.mainImageDiv}>
                            <div className={style.imageDiv}>
                                <img
                                  className={style.lockImage2}
                                  src={percentMark >= 60 ? bronze : bronzelocked}
                                  alt="Easy Medal"
                                />

                                {showBronzeAnim  && (
                                  <div className={style.animationOverlay}>
                                    <img
                                      src={sprinklesGif}
                                      alt="Celebration"
                                      className={style.sprinkleGif}
                                    />
                                  </div>
                                )}
                              </div>
                            <div className={style.imageDiv}>
                              <img
                                className={style.lockImage2}
                                src={percentMark >= 80 ? sliverrank : silverlocked}
                                alt="Medium Medal"
                              />
                            
                              {showSilverAnim && (
                                <div className={style.animationOverlay}>
                                  <img
                                    src={sprinklesGif}
                                    alt="Celebration"
                                    className={style.sprinkleGif}
                                  />
                                </div>
                              )}
                            </div>
                            <div className={style.imageDiv}>
                              <img
                                className={style.lockImage2}
                                src={
                                  assementStatus === "completed"
                                    ? goldrank
                                    : goldlocked
                                }
                                alt="Hard Medal"
                              />
                            
                              {showGoldAnim && (
                                <div className={style.animationOverlay}>
                                  <img
                                    src={sprinklesGif}
                                    alt="Celebration"
                                    className={style.sprinkleGif}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                          {/* <Snackbar
                            open={snackbar.open}
                            autoHideDuration={3000}
                            onClose={() => setSnackbar({ open: false, message: "" })}
                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                          >
                            <Alert
                              severity="success"
                              onClose={() => setSnackbar({ open: false, message: "" })}
                              sx={{ width: "100%", fontSize: "1rem" }}
                            >
                              {snackbar.message}
                            </Alert>
                          </Snackbar> */}

                          <div className={style.FinishButton}>
                            <button
                              onClick={fetchEndSession}
                              className={style.endButton}
                            >
                              End
                            </button>
                            <button
                              className={style.pauseButton}
                              onClick={fetchpauseSession}
                            >
                              Pause
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {trialUser && result ? (
                  <div className={style.bodyBottom}>
                    <div className={style.subscriptionHeader}>
                      <h4>You have successfully completed your trial!</h4>
                      <span>
                        Ready to take your English to the next level?{" "}
                      </span>
                      <p>Subscribe now and gain unlimited access to:</p>
                      <button
                        onClick={() => {
                          navigate("/subscribe", {
                            state: {
                              userID: userDetails && userDetails._id?.$oid,
                              Username: userDetails && userDetails.Username,
                              count: userDetails && userDetails.trail_count,
                              previousPath: "Summary",
                            },
                          });
                        }}
                      >
                        Subscribe Now
                      </button>
                    </div>
                    <div className={style.subscriptionGrid}>
                      <div className={style.subscriptionCard}>
                        <div className={style.subscriptionCardImageContainer}>
                          <div className={style.subscriptionCardImage}>
                            <img src={lessonImage} alt="Lesson" />
                          </div>
                        </div>
                        <div className={style.subscriptionCardText}>
                          <p>Comprehensive Lessons:</p>
                          <span>
                            {" "}
                            Master every aspect of English with native designed
                            lessons.
                          </span>
                        </div>
                      </div>
                      <div className={style.subscriptionCard}>
                        <div className={style.subscriptionCardImageContainer}>
                          <div className={style.subscriptionCardImage}>
                            <img src={motivationImage} alt="Motivation" />
                          </div>
                        </div>
                        <div className={style.subscriptionCardText}>
                          <p>Motivational Milestones:</p>
                          <span>
                            {" "}
                            Celebrate your progress and stay motivated with each
                            milestone.
                          </span>
                        </div>
                      </div>
                      <div className={style.subscriptionCard}>
                        <div className={style.subscriptionCardImageContainer}>
                          <div className={style.subscriptionCardImage}>
                            <img src={questionImage} alt="Question" />
                          </div>
                        </div>
                        <div className={style.subscriptionCardText}>
                          <p>Practice Questionnaires:</p>
                          <span>
                            {" "}
                            Measure your mastery and refine your skills through
                            targeted quizzes.
                          </span>
                        </div>
                      </div>
                      <div className={style.subscriptionCard}>
                        <div className={style.subscriptionCardImageContainer}>
                          {" "}
                          <div className={style.subscriptionCardImage}>
                            <img src={timeImage} alt="Time" />
                          </div>
                        </div>
                        <div className={style.subscriptionCardText}>
                          <p>Flexible Learning:</p>
                          <span>
                            Study anytime, anywhere, at your own pace.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={style.subscriptionBottom}>
                      <p>
                        Subscribe Today and <br />
                        Transform Your English Learning Journey!
                      </p>
                      <button
                        onClick={() => {
                          navigate("/subscribe", {
                            state: {
                              userID: userDetails && userDetails._id?.$oid,
                              Username: userDetails && userDetails.Username,
                            },
                          });
                        }}
                      >
                        Subscribe Now
                      </button>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : (
              <div className={style.info}>
                <p>No Practice found</p>
              </div>
            )}
          </>
        )}
      </div>
      {/* {ohDearResult && (<div>
                            <div className={style.resultSection}>
                            <div className={style.resultSectionHeder}>
                              <h4 style={{ color: "#ca0415ff" }}>
                                Oh dear!{" "}
                              </h4>
                              <p>
                                You're still in the process of mastering the use of gerunds as sentence subjects.
                              </p>
                            </div>
                            <div className={style.resultSectionImage}>
                              <img src={ohdearimg} alt="ohDear" />
                            </div>
                            <p>You've scored</p>
                            <p>40/100</p>
                          </div>
                          </div>)} */}

      {finishPopup ? (
        <>
          <div className={style.popupOverlay}></div>
          <div
            className={style.Popup}
            role="dialog"
            aria-labelledby="end-test-title"
            aria-describedby="end-test-description"
          >
            <div className={style.popupText}>
              <p id="end-test-title">Are you sure you want to end your practice session?</p>
            </div>
            <div className={style.PopupButton}>
              <button
                className={style.noButton}
                onClick={() => {
                  setFinishPopup(false);
                }}
                aria-label="Continue test"
              >
                No
              </button>
              <button
                className={style.yesButton}
                onClick={handleConfirmEndPractice}
                aria-label="End test"
              >
                Yes
              </button>
            </div>
            <p className={style.finishTestP} id="end-test-description">
              {/* {totalCount > 0
                ? Math.max(
                    0,
                    100 - Math.round((correctCount / totalCount) * 100)
                  )
                : 0} */}
                {endSession?.remaining > 0 && (
                  <p>
                    You still have {endSession?.remaining}% of the exercises to finish - and you can earn more points!
                  </p>
                )}
            </p>
          </div>
          {/* <div className={style.dearpopupOverlay}></div>
            <div className={style.dearPopup}>
              <img className={style.ohDear2} src={ohDear} alt="Person" />
              <div className={style.dearpopupText}>
                <p>Oh dear !</p>
              </div>
              <p>You've made a good effort so far, but we believe some key areas need</p>
              <p>strengthening before you can move forward with the exam </p>
              <div className={style.dearPopupButton}>
                <button
                  className={style.dearYesButton}
                  onClick={(e) => {
                    e.preventDefault();
                    endPractice();
                  }}
                >
                  Revisit Topic 
                </button>
              </div>
          </div> */}
        </>
      ) : (
        ""
      )}
      {/* {failedPopup && !result && (
        <div className={style.wrongAnswerPopup}>
          <div className={style.wrongAnswerPopupImage}>
            {" "}
            <img src={FailedImage} alt="Incorrect answer" />
            <div className={style.wrongAnswerPopupContent}>
              <p>
                Every mistake is an opportunity to learn and grow. <br />
                Keep going!
              </p>
            </div>
            <div className={style.wrongAnswerPopupClose}>
              <AiOutlineClose
                onClick={() => {
                  setFailedPopup(false);
                  setWrongAnswerCount(0);
                }}
              />
            </div>
          </div>
        </div>
      )} */}
      {achievementPopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.achievementPopup}>
            <div className={style.achievementPopupSection}>
              <div className={style.achievementPopupHeder}>
                <h2>Hooray!</h2>
                <p>
                  You just unlocked{" "}
                  <span>{carouselData.length} Achievements</span>
                </p>
              </div>
              <div className={style.achievementCarousel}>
                <div
                  className={style.carouselTrackContainer}
                  style={{
                    overflowX: carouselData.length > 1 ? "auto" : "hidden",
                    display: "flex",
                    justifyContent:
                      carouselData.length === 1 ? "center" : "flex-start",
                  }}
                >
                  <div
                    className={style.carouselTrack}
                    style={{
                      transform: "none",
                    }}
                  >
                    {carouselData.map((item, index) => (
                      <div key={index} className={style.carouselSlide}>
                        <div className={style.achievementPopupImage}>
                          <img src={item.active_img} alt={item.name} />
                        </div>
                        <div className={style.carouselText}>
                          <h3>{item.name}</h3>
                          <p>{item.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className={style.achievementPopupButton}>
              <button
                onClick={() => {
                  setAchievementPopup(false);
                  if (points > 0 || points > "0") {
                    setCollectPopup(true);
                  }
                }}
              >
                Collect
              </button>
            </div>
          </div>
        </>
      )}
      {collectPopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.achievementPopup}>
            <div className={style.collectPopupHeader}>
              <p>Congratulations</p>
            </div>
            <div className={style.collectPopupImageContainer}>
              <div className={style.collectPopupImage}>
                <img src={Coins} alt="Reward" />
              </div>
              <div className={style.collectPopupLottie}>
                <Lottie
                  animationData={coinsLottie}
                  loop={true}
                  duration
                  autoplay
                />
              </div>
            </div>
            <div className={style.collectPopupText}>
              <span>You receive</span>
              <h3>{points} xp</h3>
              {/* <p>500 xp for completing a module within 6 weeks</p>
            <p>100 xp for scoring above 85%</p> */}
            </div>
            <div className={style.achievementPopupButton}>
              <button
                onClick={() => {
                  setCollectPopup(false);
                  const token = userDetails && userDetails.auth_token; // Assuming `key` is the token
                  dispatch(
                    fetchUserDetails({
                      userid: userDetails && userDetails._id?.$oid,
                      token,
                    })
                  );
                }}
              >
                Collect All
              </button>
            </div>
          </div>
        </>
      )}
      {sessionPausePopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.Popup}>
            <div className={style.popupText}>
              <p>Are you sure you want to pause your practice session?</p>
            </div>
            <div className={style.popupDescription}>
              <p>
                You can pick up where you’ve left off within {sessionPause?.session_time} hours. After
                that, you’ll have to restart the exercises from the beginning.
              </p>
            </div>
            <div className={style.PopupButton}>
              <button
                className={style.noButton}
                onClick={() => {
                  setSessionPausePopup(false);
                }}
              >
                No
              </button>
              <button
                className={style.yesButton}
                onClick={() => {
                  setSessionPausePopup(false);

                  navigate("/new/learnings");
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </>
      )}

      {reloadDecisionPopup && (
        <>
          <div className={style.reloadDecisionOverlay} />
          <div className={style.reloadDecisionPopup} role="dialog" aria-modal="true">
            <div className={style.popupText}>
              <p>Do you want to resume your last session?</p>
            </div>
            <div className={style.PopupButton}>
              <button
                className={style.noButton}
                onClick={() => {
                  setReloadDecisionPopup(false);
                  setResolvedContinueFlag(false);
                }}
              >
                Start Again
              </button>
              <button
                className={style.yesButton}
                onClick={() => {
                  setReloadDecisionPopup(false);
                  setResolvedContinueFlag(true);
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </>
      )}

      {/* Medal Unlock Popup Modal */}
      {(showBronzeAnim || showSilverAnim || showGoldAnim) && (
        <div
          className={style.medalPopupOverlay}
          onClick={() => {
            setShowBronzeAnim(false);
            setShowSilverAnim(false);
            setShowGoldAnim(false);
          }}
        >
          <div
            className={style.medalPopupContainer}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className={style.medalPopupTitle}>Congratulations!</h2>
            <p className={style.medalPopupSubtext}>You received</p>
            <div className={style.medalPopupImageWrapper}>
              <div className={style.medalPopupLottieContainer}>
                <Lottie
                  animationData={NewUnlockAnimation}
                  loop={true}
                  autoplay={true}
                  style={{ width: "100%", height: "70%" }}
                />
              </div>
              <img
                src={
                  showGoldAnim
                    ? goldrank
                    : showSilverAnim
                    ? sliverrank
                    : bronze
                }
                alt="Unlocked Badge"
                className={style.medalPopupMedalImg}
              />
            </div>
            <h3 className={style.medalPopupBadgeName}>
              {showGoldAnim
                ? "Gold"
                : showSilverAnim
                ? "Silver"
                : "Bronze"}
            <p className={style.medalPopupSubtext}>badge</p>
            </h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default Practice;
